<template>
    <b-overlay :show="showoverlay" rounded="sm">
        <div class="employee-tab-inner contract-wizard-content">
            <div class="card-body container-fluid p-0">
                <b-form @submit.stop.prevent="onSubmit">
                    <b-card no-body class="border-0 bg-white no-shadow">
                        <template v-if="fdata">
                            <div class="clearfix row no-margin d-none" v-if="update_contract != 0">
                                <div class="col-md-6 d-flex align-items-center">
                                    What information do you wish to update
                                </div>
                                <div class="col-md-6">
                                    <b-form-select v-model="update_wizard" :options="wizard_options"
                                        @change="loadWizard()"></b-form-select>
                                </div>
                            </div>
                            <div
                                class="col-md-12 bg-white no-shadow payrun-wizard-container ibox employee_wizerd_padding">
                                <form-wizard ref="wizard" color="#0060C9" @on-complete="onComplete">
                                    <span class="py-2 mt-3 mb-4" slot="title"></span>
                                    <input type="hidden" v-model="fdata.employee_id" name="employee_id" />
                                    <input type="hidden" v-model="update_contract" name="contract_update" />
                                    <tab-content title="Overview" ref="tab_overview">
                                        <div class="clearfix">
                                             <!-- alpha fix- added *  -->
                                            <b-form-group id="contract_start-group"
                                            
                                                label="Please enter contract start date *" label-for="contract_start"
                                                class="my-2">
                                                <b-form-datepicker id="contract_start" name="contract_start"
                                                    v-model="fdata.contract_start" :aria-required="true"
                                                    v-validate="{ required: true, min: 3 }"
                                                    :state="validateState('contract_start')"
                                                    aria-describedby="contract_start-feedback"
                                                    data-vv-as="Contract Start Date" :disabled="isContractDisabled()"
                                                    reset-button></b-form-datepicker>
                                                <b-form-invalid-feedback id="contract_start">{{
                                                    veeErrors.first('contract_start') }}</b-form-invalid-feedback>
                                            </b-form-group>

                                            <b-form-group id="contract_end-group" label="Contract End Date"
                                                label-for="contract_end">
                                                <b-form-datepicker id="contract_end" name="contract_end"
                                                    v-model="fdata.contract_end" reset-button></b-form-datepicker>
                                                <b-form-invalid-feedback id="contract_end">{{
                                                    veeErrors.first('contract_end') }}</b-form-invalid-feedback>
                                            </b-form-group>

                                            <!--Contract effective date Start-->
                                            <b-form-group>
                                                <b-form-checkbox v-model="sameAsStartDate" @change="syncEffectiveDate">
                                                    Same as Contract Start Date
                                                </b-form-checkbox>
                                            </b-form-group>

                                            <b-form-group id="effective_date-group">
                                                 <!-- alpha fix- added mb-2 -->
                                                <label class="mb-2 mr-2" for="effective_date">Contract Effective
                                                    Date</label>
                                                <b-icon class="" icon="info-circle"
                                                    title="The Effective Date is used for documentation, historical tracking, and KPI purposes. Salary calculations are based on the Contract Start Date. Any remaining salary, if applicable, will be processed through arrear payments."
                                                    v-b-tooltip></b-icon>
                                                <b-form-datepicker id="effective_date" name="effective_date"
                                                    v-model="fdata.effective_date" :disabled="sameAsStartDate"
                                                    reset-button></b-form-datepicker>
                                                <b-form-invalid-feedback id="effective_date">{{
                                                    veeErrors.first('effective_date') }}</b-form-invalid-feedback>
                                            </b-form-group>
                                            <!--Contract effective date End-->

                                            <b-form-group id="department_id-group" label="Department" class=""
                                                label-for="department_id">
                                                <b-form-select id="department_id" name="department_id"
                                                    v-model="fdata.department_id" :disabled="disabled_edit"
                                                    v-validate="{}" :options="department"
                                                    :state="validateState('department_id')"
                                                    aria-describedby="department_id-feedback"
                                                    data-vv-as="Department"></b-form-select>
                                                <b-form-invalid-feedback id="department_id-feedback">{{
                                                    veeErrors.first('department_id') }}</b-form-invalid-feedback>
                                            </b-form-group>
                                            <b-form-group id="employee_type_id-group" label="Employee Type" class="" label-for="employee_type_id">
                                            <b-form-select id="employee_type_id" name="employee_type_id" v-model="fdata.employee_type_id" :disabled="disabled_edit" v-validate="{  }" :options="employee_type" :state="validateState('employee_type_id')" aria-describedby="employee_type_id-feedback" data-vv-as="Employee Type"></b-form-select>
                                            <b-form-invalid-feedback id="employee_type_id-feedback">{{ veeErrors.first('employee_type_id') }}</b-form-invalid-feedback>
                                            </b-form-group>
                                            <b-form-group id="jobposition_id-group" label="Job Position" class=""
                                                label-for="jobposition_id">
                                                <b-form-select id="jobposition_id" name="jobposition_id"
                                                    v-model="fdata.jobposition_id" :disabled="disabled_edit"
                                                    v-validate="{}" :options="jobposition"
                                                    :state="validateState('jobposition_id')"
                                                    aria-describedby="jobposition_id-feedback"
                                                    data-vv-as="Job Position"></b-form-select>
                                                <b-form-invalid-feedback id="jobposition_id-feedback">{{
                                                    veeErrors.first('jobposition_id') }}</b-form-invalid-feedback>
                                            </b-form-group>
                                            <b-form-group id="branch_id-group" label="Work Location" class=""
                                                label-for="branch_id">
                                                <b-form-select id="branch_id" name="branch_id" v-model="fdata.branch_id"
                                                    v-validate="{}" :options="branch"
                                                    :state="validateState('branch_id')"
                                                    aria-describedby="branch_id-feedback"
                                                    data-vv-as="Work Location"></b-form-select>
                                                <b-form-invalid-feedback id="branch_id-feedback">{{
                                                    veeErrors.first('branch_id') }}</b-form-invalid-feedback>
                                            </b-form-group>


                                            <b-form-group id="probation_period-group" label="Probation Period?"
                                                label-for="probation_period" class="my-2 custom-radio clearfix">

                                                <div class="custom-control float-left mr-3">
                                                    <input type="radio" id="prob_yes" class="custom-control-input"
                                                        name="has_probation" value="1" v-model="fdata.has_probation"
                                                        :disabled="isContractDisabled()" />
                                                    <label class="custom-control-label" for="__BVID__239">Yes </label>
                                                </div>
                                                <div class="custom-control float-left">
                                                    <input type="radio" id="prob_no" class="custom-control-input"
                                                        name="has_probation" value="0" v-model="fdata.has_probation"
                                                        :disabled="isContractDisabled()" />
                                                    <label class="custom-control-label" for="__BVID__239">No </label>
                                                </div>
                                                <!--<b-form-checkbox id="has_probation"  v-model="fdata.has_probation" name="has_probation" value="1" unchecked-value="0" :disabled="isContractDisabled()">

                                    </b-form-checkbox>-->
                                            </b-form-group>

                                            <b-form-group id="probation_start-group" label="Probation Period Start Date"
                                                label-for="probation_start" v-if="fdata.has_probation == 1" class="my-2">
                                                <b-form-datepicker id="probation_start" name="probation_start"
                                                    v-model="fdata.probation_start" :disabled="isContractDisabled()"
                                                    reset-button></b-form-datepicker>
                                            </b-form-group>
                                            <b-form-group id="probation_end-group" label="Probation Period End Date"
                                                label-for="probation_end" v-if="fdata.has_probation == 1" class="my-2">
                                                <b-form-datepicker id="probation_end" name="probation_end"
                                                    v-model="fdata.probation_end" :disabled="isContractDisabled()"
                                                    reset-button></b-form-datepicker>
                                            </b-form-group>

                                            <template v-if="fdata.has_probation == 1">
                                                <b-form-group id="probation_gross_salary-group"
                                                    label="Probation Gross Salary" label-for="probation_gross_salary">
                                                    <b-form-input class="text-right max-200 "
                                                        id="probation_gross_salary" name="probation_gross_salary"
                                                        v-model="probation_salary['probation_gross_salary']"
                                                        v-validate="{ required: true, min: 3 }"
                                                        :state="validateState('probation_gross_salary')"
                                                        aria-describedby="probation_gross_salary-feedback"
                                                        data-vv-as="Probation Gross Salary"
                                                        @input="triggerProbationGrossChange()"
                                                        :disabled="isContractDisabled()"></b-form-input>
                                                    <b-form-invalid-feedback id="probation_gross_salary-feedback">{{
                                                        veeErrors.first('probation_gross_salary')
                                                        }}</b-form-invalid-feedback>
                                                </b-form-group>
                                                <b-form-group id="pb_optimized_salary_for_max_benefit-group"
                                                    label="Do you want to optimize salary for maximum tax benefits?"
                                                    label-for="pb_optimized_salary_for_max_benefit"
                                                    class="my-2 custom-radio clearfix">
                                                    <div class="custom-control float-left mr-3">
                                                        <input type="radio" id="pb_optimized_yes"
                                                            class="custom-control-input"
                                                            name="pb_optimized_salary_for_max_benefit" value="1"
                                                            v-model="fdata.pb_optimized_salary_for_max_benefit"
                                                            @input="optimizeProbationSalary(1)"
                                                            :disabled="isContractDisabled()" />
                                                        <label class="custom-control-label">Yes </label>
                                                    </div>
                                                    <div class="custom-control float-left">
                                                        <input type="radio" id="pb_optimized_no"
                                                            class="custom-control-input"
                                                            name="pb_optimized_salary_for_max_benefit" value="0"
                                                            v-model="fdata.pb_optimized_salary_for_max_benefit"
                                                            :disabled="isContractDisabled()"
                                                            @input="pb_salary_fields_editable = 1" />
                                                        <label class="custom-control-label">No </label>
                                                    </div>
                                                    <!--<b-form-checkbox id=""  v-model="fdata.pb_optimized_salary_for_max_benefit" name="pb_optimized_salary_for_max_benefit" value="1" unchecked-value="0" @input="optimizeProbationSalary" :disabled="isContractDisabled()">
                                        </b-form-checkbox>-->
                                                </b-form-group>
                                                <!-- <template
                                                    v-if="fdata.pb_optimized_salary_for_max_benefit == 0 || fdata.pb_optimized_salary_for_max_benefit == 1">
                                                    <template
                                                        v-for="(pb_component, index) in salary_settings.probation_data">
                                                        <template
                                                            v-if="pb_component.field_key != 'probation_gross_salary'">
                                                            <div class="col-md-6 max-200 float-left pl-0"
                                                                v-bind:class="[index % 2 ? 'pr-0' : '']">
                                                                <b-form-group :id="pb_component.field_key + '-group'"
                                                                    :label="pb_component.field_title"
                                                                    :label-for="pb_component.field_key">
                                                                    <b-form-input class="text-right max-200 "
                                                                        :id="pb_component.field_key"
                                                                        :name="'contract_field_' + pb_component.id"
                                                                        v-model="probation_salary[pb_component.field_key]"
                                                                        v-validate="{ required: true, min: 3 }"
                                                                        :aria-describedby="'contract_field_' + pb_component.id + '-feedback'"
                                                                        :data-vv-as="pb_component.field_title"
                                                                        @input="checkProbationGrossSalary(pb_component.field_key)"
                                                                        :disabled="isContractDisabled() || !pb_salary_fields_editable"></b-form-input>
                                                                    <b-form-invalid-feedback
                                                                        :id="'contract_field_' + pb_component.id + '-feedback'">{{
                                                                        veeErrors.first('contract_field_'+pb_component.id)
                                                                        }}</b-form-invalid-feedback>
                                                                </b-form-group>
                                                            </div>
                                                        </template>
</template>
</template> -->

                                                <template
                                                    v-if="fdata.pb_optimized_salary_for_max_benefit == 0 || fdata.pb_optimized_salary_for_max_benefit == 1">
                                                    <div class="row align-items-end mb-2"
                                                        v-for="(pair, pIndex) in probationDataPairs"
                                                        :key="'pb-pair-' + pIndex">
                                                        <div class="col-md-6" v-for="pb_component in pair"
                                                            :key="pb_component.id">
                                                            <b-form-group :id="pb_component.field_key + '-group'"
                                                                :label="pb_component.field_title"
                                                                :label-for="pb_component.field_key">
                                                                <b-form-input class="text-right max-200 "
                                                                    :id="pb_component.field_key"
                                                                    :name="'contract_field_' + pb_component.id"
                                                                    v-model="probation_salary[pb_component.field_key]"
                                                                    v-validate="{ required: true, min: 3 }"
                                                                    :aria-describedby="'contract_field_' + pb_component.id + '-feedback'"
                                                                    :data-vv-as="pb_component.field_title"
                                                                    @input="checkProbationGrossSalary(pb_component.field_key)"
                                                                    :disabled="isContractDisabled() || !pb_salary_fields_editable"></b-form-input>
                                                                <b-form-invalid-feedback
                                                                    :id="'contract_field_' + pb_component.id + '-feedback'">{{
                                                                        veeErrors.first('contract_field_' + pb_component.id)
                                                                    }}</b-form-invalid-feedback>
                                                            </b-form-group>
                                                        </div>
                                                    </div>
                                                </template>

                                            </template>

                                            <template
                                                v-if="fdata.has_probation == 1 && salary_settings.customized_payroll_report && salary_settings.customized_payroll_report[0]['status'] == 1">

                                                <template
                                                    v-for="(customized_payroll_component, index) in salary_settings.customized_payroll_report">
                                                    <template v-if="customized_payroll_component.child_components">
                                                        <b-form-group label="Use Customized heads?"
                                                            :label-for="customized_payroll_component.field_key"
                                                            class="my-2 custom-radio clearfix">
                                                            <div class="custom-control float-left mr-3">
                                                                <input type="radio" id="non_ml_yes"
                                                                    class="custom-control-input"
                                                                    name="customized_payroll_report_probation_component"
                                                                    value="1"
                                                                    v-model="customized_payroll_report_probation_component"
                                                                    :disabled="isContractDisabled()" />
                                                                <label class="custom-control-label">Yes </label>
                                                            </div>
                                                            <div class="custom-control float-left">
                                                                <input type="radio" id="non_ml_no"
                                                                    class="custom-control-input"
                                                                    name="customized_payroll_report_probation_component"
                                                                    value="0"
                                                                    v-model="customized_payroll_report_probation_component"
                                                                    :disabled="isContractDisabled()" />
                                                                <label class="custom-control-label">No </label>
                                                            </div>
                                                        </b-form-group>
                                                        <!-- <template
                                                            v-if="customized_payroll_report_probation_component == '1'">
                                                            <div class="row clearfix">
                                                                <template
                                                                    v-for="customized_payroll_report_child in customized_payroll_component.child_components">
                                                                    <b-form-group
                                                                        v-if="customized_payroll_report_child.field_access_key.indexOf('probation_') === 0 && customized_payroll_report_child.status == 1"
                                                                        :label="customized_payroll_report_child.field_title"
                                                                        :label-for="customized_payroll_report_child.field_key"
                                                                        class="col-md-6 float-left">
                                                                        <b-form-input class="text-right max-200 "
                                                                            :id="customized_payroll_report_child.field_key"
                                                                            :name="'contract_field_' + customized_payroll_report_child.id"
                                                                            v-model="component_values[customized_payroll_report_child.field_key]"
                                                                            v-validate="{ required: false }"
                                                                            :aria-describedby="'contract_field_' + customized_payroll_report_child.id + '-feedback'"
                                                                            :data-vv-as="customized_payroll_report_child.field_title"
                                                                            :disabled="isContractDisabled()"></b-form-input>
                                                                        <b-form-invalid-feedback
                                                                            :id="'contract_field_' + customized_payroll_report_child.id + '-feedback'">{{
                                                                            veeErrors.first('contract_field_'+customized_payroll_report_child.id)
                                                                            }}</b-form-invalid-feedback>
                                                                    </b-form-group>
                                                                </template>
</div>
</template> -->

                                                        <template
                                                            v-if="customized_payroll_report_probation_component == '1'">
                                                            <div class="row align-items-end mb-2"
                                                                v-for="(pair, cpIndex) in getChildComponentPairs(customized_payroll_component.child_components, true)"
                                                                :key="'cprp-pair-' + cpIndex">
                                                                <div class="col-md-6"
                                                                    v-for="customized_payroll_report_child in pair"
                                                                    :key="customized_payroll_report_child.id">
                                                                    <b-form-group
                                                                        :label="customized_payroll_report_child.field_title"
                                                                        :label-for="customized_payroll_report_child.field_key">
                                                                        <b-form-input class="text-right max-200 "
                                                                            :id="customized_payroll_report_child.field_key"
                                                                            :name="'contract_field_' + customized_payroll_report_child.id"
                                                                            v-model="component_values[customized_payroll_report_child.field_key]"
                                                                            v-validate="{ required: false }"
                                                                            :aria-describedby="'contract_field_' + customized_payroll_report_child.id + '-feedback'"
                                                                            :data-vv-as="customized_payroll_report_child.field_title"
                                                                            :disabled="isContractDisabled()"></b-form-input>
                                                                        <b-form-invalid-feedback
                                                                            :id="'contract_field_' + customized_payroll_report_child.id + '-feedback'">{{
                                                                                veeErrors.first('contract_field_' +
                                                                            customized_payroll_report_child.id)
                                                                            }}</b-form-invalid-feedback>
                                                                    </b-form-group>
                                                                </div>
                                                            </div>
                                                        </template>
                                                    </template>
                                                </template>
                                            </template>


                                            <!-- Leave Policy -->
                                            <!--<b-form-group id="leave_policy-group" label="Leave Policy" label-for="leave_policy"  v-if="addons.includes('LeaveAttendances')">
                                    <b-form-select id="leave_policy" name="leave_policy" v-model="fdata.leave_policy" v-validate="{ required:false }" :options="leavePolicies" :state="validateState('leave_policy')" aria-describedby="leave_policy-feedback" data-vv-as="Leave Policy"></b-form-select>
                                    <b-form-invalid-feedback id="leave_policy-feedback">{{ veeErrors.first('leave_policy') }}</b-form-invalid-feedback>
                                </b-form-group>-->

                                            <b-form-group
                                                :id="addons.includes('Roster') ? 'roster-leave-policy-group' : 'leave-policy-group'"
                                                label="Leave Policy" label-for="leave_policy"
                                                v-if="addons.includes('LeaveAttendances') || addons.includes('Roster')">
                                                <b-form-select id="leave_policy" name="leave_policy"
                                                    v-model="fdata.leave_policy" v-validate="{ required: true }"
                                                    :options="addons.includes('Roster') ? rosterLeavePolicies : leavePolicies"
                                                    :state="validateState('leave_policy')"
                                                    aria-describedby="leave_policy-feedback"
                                                    data-vv-as="Leave Policy"></b-form-select>
                                                <b-form-invalid-feedback id="leave_policy-feedback">{{
                                                    veeErrors.first('leave_policy') }}</b-form-invalid-feedback>
                                            </b-form-group>


                                            <!-- Sohel: New mappings update -->
                                            <b-form-group id="show-cost-center-btn-group" label="Cost Center"
                                                class="clearfix" label-for="show-cost-center-btn">
                                                <b-button variant="primary" id="show-cost-center-btn"
                                                    @click="selectCostCenter()" :disabled="isContractDisabled()"
                                                    class="float-right pt-1 pl-1 pb-1"><b-icon icon="plus"
                                                        type="is-primary" variant="" scale="1"></b-icon> Add Cost
                                                    Center</b-button>
                                            </b-form-group>

                                               <!-- alpha fix- maked it a table formate   -->

                                                <table class="table border">
                                                <thead>
                                                    <tr class="table-head">
                                                        <td>Name</td>
                                                        <td>Percentage</td>
                                                        <td class="text-right" v-if="ce">Action</td>
                                                    </tr>
                                                </thead>

                                                <tbody>
                                                    <tr class="hover-bg table-row border-bottom mx-2"
                                                        v-for="(c, index) in cost_center" :key="c.cost_center_id">
                                                        <td>{{ getCostCenterName(c.cost_center_id) }}</td>
                                                        <td>{{ c.component_percentage }}%</td>
                                                        <td class="text-right" v-if="ce">
                                                            <b-icon class="delete-btn-red" icon="trash-fill"
                                                                role="button" aria-hidden="true" scale="1.2"
                                                                v-on:click="removeCostCenter(index)"></b-icon>
                                                        </td>
                                                    </tr>

                                                    <tr class="table-row border-bottom mx-2">
                                                        <td>Remaining:</td>
                                                        <td>{{ remainingPercentage }}%</td>
                                                        <td class="text-right" v-if="ce"></td>
                                                    </tr>
                                                </tbody>
                                            </table>

                                              <!-- alpha fix- commeted this  -->
                                            <!-- <div class="mt-3">
                                                <div class="row table-head py-2">
                                                    <div class="col-5">
                                                        Name
                                                    </div>
                                                    <div class="col-5">
                                                        Percentage
                                                    </div>
                                                    <div class="col-2 text-right">

                                                    </div>
                                                </div>
                                                <div class="row py-2" v-for="(c, index) in cost_center"
                                                    :key="c.cost_center_id">
                                                    <div class="col-5">
                                                        {{ getCostCenterName(c.cost_center_id) }}
                                                    </div>
                                                    <div class="col-5">
                                                        {{ c.component_percentage }}%
                                                    </div>
                                                    <div class="col-2 text-right">
                                                        <b-icon class="delete-btn-red" icon="trash-fill" role="button"
                                                            aria-hidden="true" scale="1.2"
                                                            v-on:click="removeCostCenter(index)"></b-icon>
                                                    </div>
                                                </div>
                                                <div class="row py-2">
                                                    <div class="col-5">
                                                        Remaining:
                                                    </div>
                                                    <div class="col-5">
                                                        {{ remainingPercentage }}%
                                                    </div>
                                                    <div class="col-2 text-right"></div>
                                                </div>
                                            </div> -->
                                            <!-- Sohel: New mappings update -->

                                            <!--<b-button type="button" variant="primary" @click="dateToFiscalYear(fdata.contract_start)">TEST</b-button>-->

                                        </div>
                                        <div class="clearfix mb-2 pb-2 mt-3">
                                            <div class="col-md-6 float-left pl-0"><b-button type="button"
                                                    variant="primary" @click="goBack()" disabled>Prev</b-button></div>
                                            <div class="col-md-6 float-right text-right pr-0 save-btn"><b-button
                                                    type="submit" variant="success" v-if="update_contract != 0"
                                                    class="mr-3 btn-primary" ref="save_finish">Save</b-button><b-button
                                                    type="button" variant="primary"
                                                    @click="moveNext('1')">Next</b-button></div>
                                        </div>
                                    </tab-content>
                                    <tab-content title="Salary Information" ref="tab_salary_info">
                                        <b-form-group id="gross-group" label="Gross Salary" label-for="gross">
                                            <b-form-input id="gross-display" class="text-right max-200 d-none"
                                                name="gross-display"
                                                v-on:change="changeMoneyFormate(fdata.gross_display)"
                                                v-model="fdata.gross_display" v-validate="{ required: false, min: 3 }"
                                                :state="validateState('gross-display')"
                                                aria-describedby="gross-feedback-display" data-vv-as="Gross Salary"
                                                :disabled="isContractDisabled()"></b-form-input>
                                            <b-form-input id="gross" class="text-right max-200 " name="gross"
                                                v-model="fdata.gross" v-validate="{ required: false, min: 3 }"
                                                :state="validateState('gross')" aria-describedby="gross-feedback"
                                                data-vv-as="Gross Salary" @input="triggerGrossChange()"
                                                :disabled="isContractDisabled()"></b-form-input>
                                            <b-form-invalid-feedback id="gross-feedback">{{ veeErrors.first('gross')
                                                }}</b-form-invalid-feedback>
                                            <b-form-invalid-feedback id="gross-feedback-display">{{
                                                veeErrors.first('gross-display')
                                                }}</b-form-invalid-feedback>
                                        </b-form-group>

                                        <b-form-group id="optimized_salary_for_max_benefit-group"
                                            label="Do you want to optimize salary for maximum tax benefits?"
                                            label-for="optimized_salary_for_max_benefit"
                                            class="my-2 custom-radio clearfix">
                                            <div class="custom-control float-left mr-3">
                                                <input type="radio" id="optimized_yes" class="custom-control-input"
                                                    name="optimized_salary_for_max_benefit" value="1"
                                                    v-model="fdata.optimized_salary_for_max_benefit"
                                                    @input="optimizeSalary(1)" :disabled="isContractDisabled()" />
                                                <label class="custom-control-label">Yes </label>
                                            </div>
                                            <div class="custom-control float-left">
                                                <input type="radio" id="optimized_no" class="custom-control-input"
                                                    name="optimized_salary_for_max_benefit" value="0"
                                                    v-model="fdata.optimized_salary_for_max_benefit"
                                                    :disabled="isContractDisabled()"
                                                    @input="salary_fields_editable = 1" />
                                                <label class="custom-control-label">No </label>
                                            </div>
                                            <!--<b-form-checkbox id="optimized_salary_for_max_benefit"  v-model="fdata.optimized_salary_for_max_benefit" name="optimized_salary_for_max_benefit" value="1" unchecked-value="0" @input="optimizeSalary" :disabled="isContractDisabled()">
                                    </b-form-checkbox>-->
                                        </b-form-group>
                                        <div class="clearfix salary-benefit-wrapper"
                                            v-if="fdata.optimized_salary_for_max_benefit == 0 || fdata.optimized_salary_for_max_benefit == 1">
                                            <template v-for="(fixed_component, index) in salary_settings.fixed">
                                                <template
                                                    v-if="fixed_component.field_key == 'basic_salary' || fixed_component.field_key == 'house_rent' || fixed_component.field_key == 'conveyance_allowance' || fixed_component.field_key == 'medical_allowance' || fixed_component.field_key.indexOf('custom_gross_salary_') === 0">
                                                    <!-- gross salary update -->
                                                    <!-- <div class="col-md-6 max-200 float-left pl-0"  v-bind:class="[index%2 ? 'pr-0' : '']"> -->
                                                    <div class="col-md-6 max-200 float-left pl-0 pr-3">
                                                        <!-- Mustafijur: 13-05-2026 -->
                                                        <b-form-group v-if="fixed_component.section_only != 1"
                                                            :id="fixed_component.field_key + '-group'"
                                                            :label="fixed_component.field_title"
                                                            :label-for="fixed_component.field_key">
                                                            <b-form-input class="text-right max-200 "
                                                                v-if="fixed_component.field_key == 'basic_salary'"
                                                                :id="fixed_component.field_key"
                                                                :name="'contract_field_' + fixed_component.id"
                                                                v-model="component_values[fixed_component.field_name]"
                                                                v-validate="{ required: false }"
                                                                :state="validateState('contract_field_' + fixed_component.id)"
                                                                :aria-describedby="'contract_field_' + fixed_component.id + '-feedback'"
                                                                :data-vv-as="fixed_component.field_title"
                                                                @input="checkGrossSalary(fixed_component.field_key)"
                                                                :disabled="isContractDisabled() || !salary_fields_editable"></b-form-input>
                                                            <b-form-input class="text-right max-200 " v-else
                                                                :id="fixed_component.field_key"
                                                                :name="'contract_field_' + fixed_component.id"
                                                                v-model="component_values[fixed_component.field_name]"
                                                                v-validate="{ required: false }"
                                                                :aria-describedby="'contract_field_' + fixed_component.id + '-feedback'"
                                                                :data-vv-as="fixed_component.field_title"
                                                                @input="checkGrossSalary(fixed_component.field_key)"
                                                                :disabled="isContractDisabled() || !salary_fields_editable"></b-form-input>
                                                            <b-form-invalid-feedback
                                                                :id="'contract_field_' + fixed_component.id + '-feedback'">{{
                                                                veeErrors.first('contract_field_'+fixed_component.id)
                                                                }}</b-form-invalid-feedback>
                                                        </b-form-group>
                                                    </div>
                                                </template>
                                            </template>
                                        </div>

                                        <template
                                            v-if="salary_settings.customized_payroll_report && salary_settings.customized_payroll_report[0]['status'] == 1">

                                            <template
                                                v-for="(customized_payroll_component, index) in salary_settings.customized_payroll_report">
                                                <template v-if="customized_payroll_component.child_components">
                                                    <b-form-group label="Use Customized heads?"
                                                        :label-for="customized_payroll_component.field_key"
                                                        class="my-2 custom-radio clearfix">
                                                        <div class="custom-control float-left mr-3">
                                                            <input type="radio" id="non_ml_yes"
                                                                class="custom-control-input"
                                                                name="customized_payroll_report_component" value="1"
                                                                v-model="customized_payroll_report_component"
                                                                :disabled="isContractDisabled()" />
                                                            <label class="custom-control-label">Yes </label>
                                                        </div>
                                                        <div class="custom-control float-left">
                                                            <input type="radio" id="non_ml_no"
                                                                class="custom-control-input"
                                                                name="customized_payroll_report_component" value="0"
                                                                v-model="customized_payroll_report_component"
                                                                :disabled="isContractDisabled()" />
                                                            <label class="custom-control-label">No </label>
                                                        </div>
                                                    </b-form-group>
                                                    <!-- <template v-if="customized_payroll_report_component == '1'">
                                                        <div class="row clearfix">
                                                            <template
                                                                v-for="customized_payroll_report_child in customized_payroll_component.child_components">
                                                                <b-form-group
                                                                    v-if="customized_payroll_report_child.field_access_key.indexOf('probation_') !== 0 && customized_payroll_report_child.status == 1"
                                                                    :label="customized_payroll_report_child.field_title"
                                                                    :label-for="customized_payroll_report_child.field_key"
                                                                    class="col-md-6 float-left">
                                                                    <b-form-input class="text-right max-200 "
                                                                        :id="customized_payroll_report_child.field_key"
                                                                        :name="'contract_field_' + customized_payroll_report_child.id"
                                                                        v-model="component_values[customized_payroll_report_child.field_key]"
                                                                        v-validate="{ required: false }"
                                                                        :aria-describedby="'contract_field_' + customized_payroll_report_child.id + '-feedback'"
                                                                        :data-vv-as="customized_payroll_report_child.field_title"
                                                                        :disabled="isContractDisabled()"></b-form-input>
                                                                    <b-form-invalid-feedback
                                                                        :id="'contract_field_' + customized_payroll_report_child.id + '-feedback'">{{
                                                                        veeErrors.first('contract_field_'+customized_payroll_report_child.id)
                                                                        }}</b-form-invalid-feedback>
                                                                </b-form-group>
                                                            </template>
    </div>
    </template> -->

                                                    <template v-if="customized_payroll_report_component == '1'">
                                                        <div class="row align-items-end mb-2"
                                                            v-for="(pair, cpIndex) in getChildComponentPairs(customized_payroll_component.child_components, false)"
                                                            :key="'cpr-pair-' + cpIndex">
                                                            <div class="col-md-6"
                                                                v-for="customized_payroll_report_child in pair"
                                                                :key="customized_payroll_report_child.id">
                                                                <b-form-group
                                                                    :label="customized_payroll_report_child.field_title"
                                                                    :label-for="customized_payroll_report_child.field_key">
                                                                    <b-form-input class="text-right max-200 "
                                                                        :id="customized_payroll_report_child.field_key"
                                                                        :name="'contract_field_' + customized_payroll_report_child.id"
                                                                        v-model="component_values[customized_payroll_report_child.field_key]"
                                                                        v-validate="{ required: false }"
                                                                        :aria-describedby="'contract_field_' + customized_payroll_report_child.id + '-feedback'"
                                                                        :data-vv-as="customized_payroll_report_child.field_title"
                                                                        :disabled="isContractDisabled()"></b-form-input>
                                                                    <b-form-invalid-feedback
                                                                        :id="'contract_field_' + customized_payroll_report_child.id + '-feedback'">{{
                                                                            veeErrors.first('contract_field_' +
                                                                        customized_payroll_report_child.id)
                                                                        }}</b-form-invalid-feedback>
                                                                </b-form-group>
                                                            </div>
                                                        </div>
                                                    </template>
                                                </template>
                                            </template>
                                        </template>

                                        <template v-for="(fixed_component, index) in salary_settings.fixed">

                                            <template
                                                v-if="fixed_component.field_key == 'other_monthly_allowance' && fixed_component.child_components">
                                                <b-form-group label="Do you offer any other monthly allowance?"
                                                    :label-for="fixed_component.field_key"
                                                    class="my-2 custom-radio clearfix">
                                                    <div class="custom-control float-left mr-3">
                                                        <input type="radio" id="om_al_yes" class="custom-control-input"
                                                            name="other_monthly_allowance_check" value="1"
                                                            v-model="other_m_allowence"
                                                            :disabled="isContractDisabled()" />
                                                        <label class="custom-control-label">Yes </label>
                                                    </div>
                                                    <div class="custom-control float-left">
                                                        <input type="radio" id="om_al_no" class="custom-control-input"
                                                            name="other_monthly_allowance_check" value="0"
                                                            v-model="other_m_allowence"
                                                            :disabled="isContractDisabled()" />
                                                        <label class="custom-control-label">No </label>
                                                    </div>
                                                    <b-button v-if="other_m_allowence == '1'" variant="primary"
                                                        id="show-btn"
                                                        @click="selectChildComponents(fixed_component.field_name, fixed_component.field_title)"
                                                        :disabled="isContractDisabled()"
                                                        class="float-right pt-1 pl-1 pb-1"><b-icon icon="plus"
                                                            type="is-primary" variant="" scale="1"></b-icon> Add /
                                                        Update</b-button>
                                                </b-form-group>
                                                <template v-if="other_m_allowence == '1'">
                                                    <template v-if="fixed_component.child_components">
                                                        <template
                                                            v-for="fixed_child in fixed_component.child_components">
                                                            <b-form-group v-if="fixed_child.is_checked == 1"
                                                                :label="fixed_child.field_title"
                                                                :label-for="fixed_child.field_key" class="clearfix">
                                                                <b-form-input class="text-right max-200 "
                                                                    :id="fixed_child.field_key"
                                                                    :name="'contract_field_' + fixed_child.id"
                                                                    v-model="component_values[fixed_child.field_key]"
                                                                    v-validate="{ required: false }"
                                                                    :aria-describedby="'contract_field_' + fixed_child.id + '-feedback'"
                                                                    :data-vv-as="fixed_child.field_title"
                                                                    :disabled="isContractDisabled()"></b-form-input>
                                                                <b-form-invalid-feedback
                                                                    :id="'contract_field_' + fixed_child.id + '-feedback'">{{
                                                                    veeErrors.first('contract_field_'+fixed_child.id)
                                                                    }}</b-form-invalid-feedback>
                                                            </b-form-group>
                                                        </template>
                                                    </template>
                                                </template>
                                            </template>


                                            <template v-if="fixed_component.field_key == 'conveyance_personal_private'">
                                                <b-form-group :label-for="fixed_component.field_key"
                                                    label="Do you offer conveyance for personal/private use?"
                                                    class="my-2 custom-radio clearfix">
                                                    <!--<b-form-checkbox :id="'contract_field_date_range_'+fixed_component.id"  v-model="component_values[fixed_component.field_key]" :name="'contract_field_date_range_'+fixed_component.id" value="1" unchecked-value="0" v-validate="{ required: false }" @input="setDateRangeValue(fixed_component.field_key,$event)" :disabled="isContractDisabled()">
                                        </b-form-checkbox>-->
                                                    <div class="custom-control float-left mr-3">
                                                        <input type="radio" class="custom-control-input"
                                                            :id="'contract_field_date_range_' + fixed_component.id"
                                                            :name="'contract_field_date_range_' + fixed_component.id"
                                                            value="1"
                                                            v-model="component_values[fixed_component.field_key]"
                                                            @input="setDateRangeValue(fixed_component.field_key, $event)"
                                                            v-validate="{ required: false }"
                                                            :disabled="isContractDisabled()" />
                                                        <label class="custom-control-label">Yes </label>
                                                    </div>
                                                    <div class="custom-control float-left">
                                                        <input type="radio" class="custom-control-input"
                                                            :id="'contract_field_date_range_' + fixed_component.id + '_1'"
                                                            :name="'contract_field_date_range_' + fixed_component.id"
                                                            value="0"
                                                            v-model="component_values[fixed_component.field_key]"
                                                            v-validate="{ required: false }"
                                                            :disabled="isContractDisabled()" />
                                                        <label class="custom-control-label">No </label>
                                                    </div>
                                                </b-form-group>
                                                <!--<b-form-group :id="fixed_component.field_key+'start-group'" label="Start Date" :label-for="fixed_component.field_key+'_start_date'" v-if="component_values[fixed_component.field_name] == 1">
                                        <b-form-datepicker :id="fixed_component.field_key+'_start_date'" :name="'contract_field_date_type_'+salary_settings.reserved_data[fixed_component.field_key].start.id" v-model="component_values[fixed_component.field_key+'_start_date']" :disabled="isContractDisabled()" reset-button></b-form-datepicker>
                                    </b-form-group>
                                <b-form-group :id="fixed_component.field_key+'end-group'" label="End Date" :label-for="fixed_component.field_key+'_end_date'" v-if="component_values[fixed_component.field_name] == 1">
                                        <b-form-datepicker :id="fixed_component.field_key+'_end_date'" :name="'contract_field_date_type_'+salary_settings.reserved_data[fixed_component.field_key].end.id" v-model="component_values[fixed_component.field_key+'_end_date']" :disabled="isContractDisabled()" reset-button></b-form-datepicker>
                                    </b-form-group> -->

                                                <!-- New slabs for conveyance personal/private related updates: Sohel -->
                                                <b-form-group v-if="component_values[fixed_component.field_name] == 1"
                                                    id="conveyance_personal_private_cars_upto_1500_cc-group"
                                                    label="Up to 1500 cc - enter number of cars provided"
                                                    label-for="conveyance_personal_private_cars_upto_1500_cc">
                                                    <b-form-input class="text-right max-200 "
                                                        id="conveyance_personal_private_cars_upto_1500_cc"
                                                        name="conveyance_personal_private_cars_upto_1500_cc"
                                                        v-model="fdata.conveyance_personal_private_cars_upto_1500_cc"
                                                        v-validate="{ required: false }"
                                                        :state="validateState('conveyance_personal_private_cars_upto_1500_cc')"
                                                        aria-describedby="conveyance_personal_private_cars_upto_1500_cc-feedback"
                                                        data-vv-as="Up to 2500cc � enter number of cars provided"
                                                        @change="triggerFormatData()"
                                                        :disabled="isContractDisabled()"></b-form-input>
                                                    <b-form-invalid-feedback
                                                        id="conveyance_personal_private_cars_upto_1500_cc-feedback">{{
                                                            veeErrors.first('conveyance_personal_private_cars_upto_1500_cc')
                                                        }}</b-form-invalid-feedback>
                                                </b-form-group>

                                                <b-form-group v-if="component_values[fixed_component.field_name] == 1"
                                                    id="conveyance_personal_private_cars_1501_to_2000_cc-group"
                                                    label="From 1501 to 2000 cc - enter number of cars provided"
                                                    label-for="conveyance_personal_private_cars_1501_to_2000_cc">
                                                    <b-form-input class="text-right max-200 "
                                                        id="conveyance_personal_private_cars_1501_to_2000_cc"
                                                        name="conveyance_personal_private_cars_1501_to_2000_cc"
                                                        v-model="fdata.conveyance_personal_private_cars_1501_to_2000_cc"
                                                        v-validate="{ required: false }"
                                                        :state="validateState('conveyance_personal_private_cars_1501_to_2000_cc')"
                                                        aria-describedby="conveyance_personal_private_cars_1501_to_2000_cc-feedback"
                                                        data-vv-as="Up to 2500cc � enter number of cars provided"
                                                        @change="triggerFormatData()"
                                                        :disabled="isContractDisabled()"></b-form-input>
                                                    <b-form-invalid-feedback
                                                        id="conveyance_personal_private_cars_1501_to_2000_cc-feedback">{{
                                                            veeErrors.first('conveyance_personal_private_cars_1501_to_2000_cc')
                                                        }}</b-form-invalid-feedback>
                                                </b-form-group>

                                                <b-form-group v-if="component_values[fixed_component.field_name] == 1"
                                                    id="conveyance_personal_private_cars_2001_to_2500_cc-group"
                                                    label="From 2001 to 2500 cc - enter number of cars provided"
                                                    label-for="conveyance_personal_private_cars_2001_to_2500_cc">
                                                    <b-form-input class="text-right max-200 "
                                                        id="conveyance_personal_private_cars_2001_to_2500_cc"
                                                        name="conveyance_personal_private_cars_2001_to_2500_cc"
                                                        v-model="fdata.conveyance_personal_private_cars_2001_to_2500_cc"
                                                        v-validate="{ required: false }"
                                                        :state="validateState('conveyancconveyance_personal_private_cars_2001_to_2500_cce_personal_private_cars_upto_2500_cc')"
                                                        aria-describedby="conveyance_personal_private_cars_2001_to_2500_cc-feedback"
                                                        data-vv-as="Up to 2500cc � enter number of cars provided"
                                                        @change="triggerFormatData()"
                                                        :disabled="isContractDisabled()"></b-form-input>
                                                    <b-form-invalid-feedback
                                                        id="conveyance_personal_private_cars_2001_to_2500_cc-feedback">{{
                                                            veeErrors.first('conveyance_personal_private_cars_2001_to_2500_cc')
                                                        }}</b-form-invalid-feedback>
                                                </b-form-group>
                                                <!-- New slabs for conveyance personal/private related updates: Sohel -->

                                                <b-form-group v-if="component_values[fixed_component.field_name] == 1"
                                                    id="conveyance_personal_private_cars_above_2500_cc-group"
                                                    label="Above 2500cc - enter number of cars provided"
                                                    label-for="conveyance_personal_private_cars_above_2500_cc">
                                                    <b-form-input class="text-right max-200 "
                                                        id="conveyance_personal_private_cars_above_2500_cc"
                                                        name="conveyance_personal_private_cars_above_2500_cc"
                                                        v-model="fdata.conveyance_personal_private_cars_above_2500_cc"
                                                        v-validate="{ required: false }"
                                                        :state="validateState('conveyance_personal_private_cars_above_2500_cc')"
                                                        aria-describedby="conveyance_personal_private_cars_above_2500_cc-feedback"
                                                        data-vv-as="Above 2500cc � enter number of cars provided"
                                                        @change="triggerFormatData()"
                                                        :disabled="isContractDisabled()"></b-form-input>
                                                    <b-form-invalid-feedback
                                                        id="conveyance_personal_private_cars_above_2500_cc-feedback">{{
                                                            veeErrors.first('conveyance_personal_private_cars_above_2500_cc')
                                                        }}</b-form-invalid-feedback>
                                                </b-form-group>

                                            </template>

                                            <template v-if="fixed_component.field_key == 'rent_free_accommodation'">
                                                <b-form-group :label-for="fixed_component.field_key"
                                                    label="Do you offer rent-free accommodation?"
                                                    class="my-2 custom-radio clearfix">
                                                    <div class="custom-control float-left mr-3">
                                                        <input type="radio" class="custom-control-input"
                                                            :id="'contract_field_date_range_' + fixed_component.id"
                                                            :name="'contract_field_date_range_' + fixed_component.id"
                                                            value="1"
                                                            v-model="component_values[fixed_component.field_key]"
                                                            @input="setDateRangeValue(fixed_component.field_key, $event)"
                                                            v-validate="{ required: false }"
                                                            :disabled="isContractDisabled()" />
                                                        <label class="custom-control-label">Yes </label>
                                                    </div>
                                                    <div class="custom-control float-left">
                                                        <input type="radio" class="custom-control-input"
                                                            :id="'contract_field_date_range_' + fixed_component.id + '_1'"
                                                            :name="'contract_field_date_range_' + fixed_component.id"
                                                            value="0"
                                                            v-model="component_values[fixed_component.field_key]"
                                                            v-validate="{ required: false }"
                                                            :disabled="isContractDisabled()" />
                                                        <label class="custom-control-label">No </label>
                                                    </div>




                                                    <!--<b-form-checkbox :id="'contract_field_date_range_'+fixed_component.id"  v-model="component_values[fixed_component.field_key]" :name="'contract_field_date_range_'+fixed_component.id" value="1" unchecked-value="0" v-validate="{ required: false }" @input="setDateRangeValue(fixed_component.field_key,$event)" :disabled="isContractDisabled()">
                                            {{fixed_component.field_title}}
                                        </b-form-checkbox>-->
                                                </b-form-group>

                                                <!--<b-form-group :id="fixed_component.field_key+'start-group'" label="Start Date" :label-for="fixed_component.field_key+'_start_date'" v-if="component_values[fixed_component.field_name] == 1">
                                        <b-form-datepicker :id="fixed_component.field_key+'_start_date'" :name="'contract_field_date_type_'+salary_settings.reserved_data[fixed_component.field_key].start.id" v-model="component_values[fixed_component.field_key+'_start_date']" :disabled="isContractDisabled()" reset-button></b-form-datepicker>
                                    </b-form-group>


                                    <b-form-group :id="fixed_component.field_key+'end-group'" label="End Date" :label-for="fixed_component.field_key+'_end_date'" v-if="component_values[fixed_component.field_name] == 1">
                                        <b-form-datepicker :id="fixed_component.field_key+'_end_date'" :name="'contract_field_date_type_'+salary_settings.reserved_data[fixed_component.field_key].end.id" v-model="component_values[fixed_component.field_key+'_end_date']" :disabled="isContractDisabled()" reset-button></b-form-datepicker>
                                    </b-form-group>-->


                                                <!--<b-form-group v-if="component_values['rent_free_accommodation']==1" id="rental_amount-group" label="Monthly Rental Amount" label-for="rental_amount">
                                        <b-form-input class="text-right max-200 " id="rental_amount" name="rental_amount" v-model="fdata.rental_amount" v-validate="{ required: false }" :state="validateState('rental_amount')" aria-describedby="rental_amount-feedback" data-vv-as="Monthly Rental Amount" @change="triggerFormatData()" :disabled="isContractDisabled()"></b-form-input>
                                        <b-form-invalid-feedback id="rental_amount-feedback">{{ veeErrors.first('rental_amount') }}</b-form-invalid-feedback>
                                    </b-form-group>-->
                                                <!-- non-cash update satrt -->
                                                <template v-if="component_values['rent_free_accommodation'] == 1">
                                                    <b-form-group id="accomodation_coverage-group"
                                                        label="Accommodation Coverage" class=""
                                                        label-for="accomodation_coverage">
                                                        <b-form-select id="accomodation_coverage"
                                                            name="accomodation_coverage" v-model="accomodation_coverage"
                                                            v-validate="{}" :options="accomodation_coverages"
                                                            :state="validateState('accomodation_coverage')"
                                                            aria-describedby="accomodation_coverage-feedback"
                                                            data-vv-as="Accommodation Coverage"
                                                            @change="triggerRentalAmountChange()"></b-form-select>
                                                        <b-form-invalid-feedback id="accomodation_coverage-feedback">{{
                                                            veeErrors.first('accomodation_coverage')
                                                            }}</b-form-invalid-feedback>
                                                    </b-form-group>
                                                    <b-form-group id="rental_amount-group" label="Monthly Rental Amount"
                                                        label-for="rental_amount">
                                                        <b-form-input class="text-right max-200 " id="rental_amount"
                                                            name="rental_amount" v-model="fdata.rental_amount"
                                                            v-validate="{ required: false }"
                                                            :state="validateState('rental_amount')"
                                                            aria-describedby="rental_amount-feedback"
                                                            data-vv-as="Monthly Rental Amount"
                                                            @keyup="triggerRentalAmountChange()"
                                                            :disabled="isContractDisabled()"></b-form-input>
                                                        <b-form-invalid-feedback id="rental_amount-feedback">{{
                                                            veeErrors.first('rental_amount')
                                                            }}</b-form-invalid-feedback>
                                                    </b-form-group>
                                                    <b-form-group id="rent_paid_by_employee-group"
                                                        label="Rent Paid by Employee" label-for="rent_paid_by_employee">
                                                        <b-form-input class="text-right max-200 "
                                                            id="rent_paid_by_employee" name="rent_paid_by_employee"
                                                            v-model="fdata.rent_paid_by_employee"
                                                            v-validate="{ required: false }"
                                                            :state="validateState('rent_paid_by_employee')"
                                                            aria-describedby="rent_paid_by_employee-feedback"
                                                            data-vv-as="Rent Paid by Employee"
                                                            @keyup="triggerRentalAmountChange()"
                                                            :disabled="isContractDisabled() || accomodation_coverage == 2"></b-form-input>
                                                        <b-form-invalid-feedback id="rent_paid_by_employee-feedback">{{
                                                            veeErrors.first('rent_paid_by_employee')
                                                            }}</b-form-invalid-feedback>
                                                    </b-form-group>
                                                    <b-form-group id="perquisite_amount-group" label="Perquisite Amount"
                                                        label-for="perquisite_amount">
                                                        <b-form-input class="text-right max-200 " id="perquisite_amount"
                                                            name="perquisite_amount" v-model="perquisite_amount"
                                                            v-validate="{ required: false }"
                                                            :state="validateState('perquisite_amount')"
                                                            aria-describedby="perquisite_amount-feedback"
                                                            data-vv-as="Perquisite Amount" @change="triggerFormatData()"
                                                            :disabled="perquisiteIsDisable"></b-form-input>
                                                        <b-form-invalid-feedback id="perquisite_amount-feedback">{{
                                                            veeErrors.first('perquisite_amount')
                                                            }}</b-form-invalid-feedback>
                                                    </b-form-group>
                                                </template>
                                                <!-- non-cash update end -->

                                            </template>
                                        </template>

                                        <b-form-group id="tax_policy-group" label="Tax Policy" label-for="tax_policy">
                                            <b-form-select v-model="fdata.tax_policy" :options="tax_policies"
                                                v-validate="{ required: false }"></b-form-select>
                                        </b-form-group>

                                        <div class="clearfix mb-2 pb-2 mt-3">
                                            <div class="col-md-6 float-left pl-0"><b-button type="button"
                                                    variant="primary" @click="goBack()">Prev</b-button></div>
                                            <div class="col-md-6 float-right text-right pr-0"><b-button type="submit"
                                                    variant="success" v-if="update_contract != 0"
                                                    class="mr-3 btn-primary">Save</b-button><b-button type="button"
                                                    variant="primary" @click="moveNext('2')">Next</b-button></div>
                                        </div>
                                    </tab-content>
                                    <tab-content title="Any Non-Taxable Monthly Allowance" ref="tab_nontext_allowance">
                                        <template v-for="(fixed_component, index) in salary_settings.fixed">
                                            <template
                                                v-if="fixed_component.field_key == 'other_non_taxable_monthly_allowance' && fixed_component.child_components">
                                                <b-form-group label="Any Non-Taxable Monthly Allowance?"
                                                    :label-for="fixed_component.field_key"
                                                    class="my-2 custom-radio clearfix">
                                                    <div class="custom-control float-left mr-3">
                                                        <input type="radio" id="non_ml_yes" class="custom-control-input"
                                                            name="nontaxable_monthly_allowance_check" value="1"
                                                            v-model="nontaxable_m_allowence"
                                                            :disabled="isContractDisabled()" />
                                                        <label class="custom-control-label">Yes </label>
                                                    </div>
                                                    <div class="custom-control float-left">
                                                        <input type="radio" id="non_ml_no" class="custom-control-input"
                                                            name="nontaxable_monthly_allowance_check" value="0"
                                                            v-model="nontaxable_m_allowence"
                                                            :disabled="isContractDisabled()" />
                                                        <label class="custom-control-label">No </label>
                                                    </div>
                                                    <b-button v-if="nontaxable_m_allowence == '1'" variant="primary"
                                                        id="show-btn"
                                                        @click="selectChildComponents(fixed_component.field_name, fixed_component.field_title)"
                                                        :disabled="isContractDisabled()"
                                                        class="float-right pt-1 pl-1 pb-1"><b-icon icon="plus"
                                                            type="is-primary" variant="" scale="1"></b-icon> Add /
                                                        Update</b-button>
                                                </b-form-group>
                                                <template v-if="nontaxable_m_allowence == '1'">
                                                    <template v-if="fixed_component.child_components">
                                                        <template
                                                            v-for="fixed_child in fixed_component.child_components">
                                                            <b-form-group v-if="fixed_child.is_checked == 1"
                                                                :label="fixed_child.field_title"
                                                                :label-for="fixed_child.field_key" class="clearfix">
                                                                <b-form-input class="text-right max-200 "
                                                                    :id="fixed_child.field_key"
                                                                    :name="'contract_field_' + fixed_child.id"
                                                                    v-model="component_values[fixed_child.field_key]"
                                                                    v-validate="{ required: false }"
                                                                    :aria-describedby="'contract_field_' + fixed_child.id + '-feedback'"
                                                                    :data-vv-as="fixed_child.field_title"
                                                                    :disabled="isContractDisabled()"></b-form-input>
                                                                <b-form-invalid-feedback
                                                                    :id="'contract_field_' + fixed_child.id + '-feedback'">{{
                                                                    veeErrors.first('contract_field_'+fixed_child.id)
                                                                    }}</b-form-invalid-feedback>
                                                            </b-form-group>
                                                        </template>
                                                    </template>
                                                </template>
                                            </template>
                                            <template
                                                v-else-if="fixed_component.field_key == 'other_non_taxable_monthly_allowance'">
                                                <p>Any Non-Taxable Monthly Allowance is not available for this company.
                                                    Please add some fields from company payment settings first if you
                                                    want to add any field here.</p>
                                            </template>
                                        </template>
                                        <div class="clearfix mb-2 pb-2 mt-3">
                                            <div class="col-md-6 float-left ml-0 pl-0"><b-button type="button"
                                                    variant="primary" @click="goBack()">Prev</b-button></div>
                                            <div class="col-md-6 float-right text-right pr-0"><b-button type="submit"
                                                    variant="success" v-if="update_contract != 0"
                                                    class="mr-3 btn-primary">Save</b-button><b-button type="button"
                                                    variant="primary" @click="moveNext()">Next</b-button></div>
                                        </div>
                                    </tab-content>



                                    <tab-content title="Any post-gross deduction" ref="tab_post_deduction">
                                        <template v-for="(fixed_deduction, index) in salary_settings.fixed_deduction">
                                            <template
                                                v-if="fixed_deduction.field_key == 'other_post_gross_deduction' && fixed_deduction.child_components">
                                                <b-form-group v-if="fixed_deduction.section_only != 1"
                                                    :label="fixed_deduction.field_title"
                                                    :label-for="fixed_deduction.field_key">
                                                    <b-form-input class="text-right max-200 "
                                                        :id="fixed_deduction.field_key"
                                                        :name="'contract_field_' + fixed_deduction.id"
                                                        v-model="component_values[fixed_deduction.field_name]"
                                                        v-validate="{ required: false }"
                                                        :aria-describedby="'contract_field_' + fixed_deduction.id + '-feedback'"
                                                        :data-vv-as="fixed_deduction.field_title"
                                                        :disabled="isContractDisabled()"></b-form-input>
                                                    <b-form-invalid-feedback
                                                        :id="'contract_field_' + fixed_deduction.id + '-feedback'">{{
                                                        veeErrors.first('contract_field_'+fixed_deduction.id)
                                                        }}</b-form-invalid-feedback>
                                                </b-form-group>

                                                <b-form-group v-else label="Any post-gross deduction?"
                                                    :label-for="fixed_deduction.field_key"
                                                    class="my-2 custom-radio clearfix">
                                                    <div class="custom-control float-left mr-3">
                                                        <input type="radio" id="post_gd_yes"
                                                            class="custom-control-input"
                                                            name="post_gross_deduction_check" value="1"
                                                            v-model="post_gd" :disabled="isContractDisabled()" />
                                                        <label class="custom-control-label">Yes </label>
                                                    </div>
                                                    <div class="custom-control float-left">
                                                        <input type="radio" id="post_gd_no" class="custom-control-input"
                                                            name="post_gross_deduction_check" value="0"
                                                            v-model="post_gd" :disabled="isContractDisabled()" />
                                                        <label class="custom-control-label">No </label>
                                                    </div>
                                                    <b-button v-if="post_gd == '1'"
                                                        :id="'show-btn' + fixed_deduction.field_name" variant="primary"
                                                        @click="selectChildComponents(fixed_deduction.field_name, fixed_deduction.field_title)"
                                                        :disabled="isContractDisabled()"
                                                        class="float-right pt-1 pl-1 pb-1 pt-1 pl-1 pb-1"><b-icon
                                                            icon="plus" type="is-primary" variant="" scale="1"></b-icon>
                                                        Add / Update</b-button>
                                                </b-form-group>
                                                <template v-if="post_gd == '1'">
                                                    <template v-if="fixed_deduction.child_components">
                                                        <template
                                                            v-for="fixed_deduction_child in fixed_deduction.child_components">
                                                            <b-form-group v-if="fixed_deduction_child.is_checked == 1"
                                                                :label="fixed_deduction_child.field_title"
                                                                :label-for="fixed_deduction_child.field_key"
                                                                class="clearfix">
                                                                <b-form-input class="text-right max-200 "
                                                                    :id="fixed_deduction_child.field_key"
                                                                    :name="'contract_field_' + fixed_deduction_child.id"
                                                                    v-model="component_values[fixed_deduction_child.field_key]"
                                                                    v-validate="{ required: false }"
                                                                    :aria-describedby="'contract_field_' + fixed_deduction_child.id + '-feedback'"
                                                                    :data-vv-as="fixed_deduction_child.field_title"
                                                                    :disabled="isContractDisabled()"></b-form-input>
                                                                <b-form-invalid-feedback
                                                                    :id="'contract_field_' + fixed_deduction_child.id + '-feedback'">{{
                                                                    veeErrors.first('contract_field_'+fixed_deduction_child.id)
                                                                    }}</b-form-invalid-feedback>
                                                            </b-form-group>
                                                        </template>
                                                    </template>
                                                </template>
                                            </template>
                                            <template
                                                v-else-if="fixed_deduction.field_key == 'other_post_gross_deduction'">
                                                <p>Any post-gross deduction is not available for this company. Please
                                                    add some fields from company payment settings first if you want to
                                                    add any field here.</p>
                                            </template>
                                        </template>

                                        <div class="clearfix mb-2 pb-2 mt-3">
                                            <div class="col-md-6 float-left ml-0 pl-0"><b-button type="button"
                                                    variant="primary" @click="goBack()">Prev</b-button></div>
                                            <div class="col-md-6 float-right text-right pr-0"><b-button type="submit"
                                                    variant="success" v-if="update_contract != 0"
                                                    class="mr-3 btn-primary">Save</b-button><b-button type="button"
                                                    variant="primary" @click="moveNext()">Next</b-button></div>
                                        </div>
                                    </tab-content>


                                    <tab-content title="Contracted Variable Benefits"
                                        ref="tab_contracted_variable_benefits">
                                        <template
                                            v-for="(contracted_vb_component, index) in salary_settings.contracted_variable_benefits">
                                            <template
                                                v-if="contracted_vb_component.field_key == 'contracted_variable_benefits' && contracted_vb_component.child_components">
                                                <b-form-group label="Contracted Variable Benefits?"
                                                    :label-for="contracted_vb_component.field_key"
                                                    class="my-2 custom-radio clearfix">
                                                    <div class="custom-control float-left mr-3">
                                                        <input type="radio" id="non_ml_yes" class="custom-control-input"
                                                            name="contracted_variable_benefit_check" value="1"
                                                            v-model="contracted_vbenifit_component"
                                                            :disabled="isContractDisabled()" />
                                                        <label class="custom-control-label">Yes </label>
                                                    </div>
                                                    <div class="custom-control float-left">
                                                        <input type="radio" id="non_ml_no" class="custom-control-input"
                                                            name="contracted_variable_benefit_check" value="0"
                                                            v-model="contracted_vbenifit_component"
                                                            :disabled="isContractDisabled()" />
                                                        <label class="custom-control-label">No </label>
                                                    </div>
                                                    <b-button v-if="contracted_vbenifit_component == '1'"
                                                        variant="primary" id="show-btn"
                                                        @click="selectChildComponents(contracted_vb_component.field_name, contracted_vb_component.field_title)"
                                                        :disabled="isContractDisabled()"
                                                        class="float-right pt-1 pl-1 pb-1"><b-icon icon="plus"
                                                            type="is-primary" variant="" scale="1"></b-icon> Add /
                                                        Update</b-button>
                                                </b-form-group>
                                                <template v-if="contracted_vbenifit_component == '1'">
                                                    <template v-if="contracted_vb_component.child_components">
                                                        <template
                                                            v-for="contracted_vb_child in contracted_vb_component.child_components">
                                                            <b-form-group v-if="contracted_vb_child.is_checked == 1"
                                                                :label="contracted_vb_child.field_title"
                                                                :label-for="contracted_vb_child.field_key"
                                                                class="clearfix">
                                                                <b-form-input class="text-right max-200 "
                                                                    :id="contracted_vb_child.field_key"
                                                                    :name="'contract_field_' + contracted_vb_child.id"
                                                                    v-model="component_values[contracted_vb_child.field_key]"
                                                                    v-validate="{ required: false }"
                                                                    :aria-describedby="'contract_field_' + contracted_vb_child.id + '-feedback'"
                                                                    :data-vv-as="contracted_vb_child.field_title"
                                                                    :disabled="isContractDisabled()"></b-form-input>
                                                                <b-form-invalid-feedback
                                                                    :id="'contract_field_' + contracted_vb_child.id + '-feedback'">{{
                                                                    veeErrors.first('contract_field_'+contracted_vb_child.id)
                                                                    }}</b-form-invalid-feedback>
                                                            </b-form-group>
                                                        </template>
                                                    </template>
                                                </template>
                                            </template>
                                            <template
                                                v-else-if="contracted_vb_component.field_key == 'contracted_variable_benefits'">
                                                <p>Contracted Variable Benefits are not available for this company.
                                                    Please add some fields from company payment settings first if you
                                                    want to add any field here.</p>
                                            </template>
                                        </template>
                                        <!--<div class="clearfix mb-2 pb-2 mt-3"><div class="col-md-6 float-left pl-0"><b-button type="button" variant="primary" @click="goBack()">Prev</b-button></div><div class="col-md-6 float-right text-right pr-0"><b-button type="submit" variant="success" >Save &amp; Finish</b-button></div></div>-->
                                        <div class="clearfix mb-2 pb-2 mt-3">
                                            <div class="col-md-6 float-left pl-0"><b-button type="button"
                                                    variant="primary" @click="goBack()">Prev</b-button></div>
                                            <div class="col-md-6 float-right text-right pr-0"><b-button type="submit"
                                                    variant="success" v-if="update_contract != 0"
                                                    class="mr-3 btn-primary">Save</b-button><b-button type="button"
                                                    variant="primary" @click="moveNext()">Next</b-button></div>
                                        </div><!-- custom field changes -->
                                    </tab-content>

                                    <!-- custom field changes start -->
                                    <tab-content title="Custom Options" ref="tab_contract_custom">
                                        <template v-if="customfieldsdata">
                                            <template v-for="(custom_attribute, index) in customfieldsdata">
                                                <b-form-group id="label-group" :label="custom_attribute.label"
                                                    :label-for="custom_attribute.label">
                                                    <template v-if="custom_attribute.type == 1">
                                                        <!-- Abdullah 17-05-26 added class  -->
                                                        <b-form-input class="text-right max-200 "
                                                            v-model="ccdata[custom_attribute.id]"></b-form-input>
                                                    </template>
                                                    <template v-else-if="custom_attribute.type == 3">
                                                        <b-form-datepicker v-model="ccdata[custom_attribute.id]"
                                                            class="mb-2"></b-form-datepicker>
                                                    </template>
                                                    <template v-else-if="custom_attribute.type == 4">
                                                        <!-- Abdullah 17-05-26 added class  -->
                                                        <b-form-input class="text-right max-200 "
                                                            v-model="ccdata[custom_attribute.id]"></b-form-input>
                                                    </template>
                                                    <template v-else-if="custom_attribute.type == 6">
                                                        <b-form-select v-model="ccdata[custom_attribute.id]"
                                                            :options="yes_no"></b-form-select>
                                                    </template>
                                                    <template v-else-if="custom_attribute.type == 7">
                                                        <b-form-select v-model="ccdata[custom_attribute.id]"
                                                            :options="custom_attribute.options"></b-form-select>
                                                    </template>
                                                </b-form-group>
                                            </template>
                                        </template>
                                        <template v-else></template>
                                        <div class="clearfix mb-2 pb-2 mt-3">
                                            <div class="col-md-6 float-left pl-0"><b-button type="button"
                                                    variant="primary" @click="goBack()">Prev</b-button></div>
                                            <div class="col-md-6 float-right text-right pr-0"><b-button type="submit"
                                                    variant="success" class="btn-primary">Save &amp; Finish</b-button>
                                            </div>
                                        </div>
                                    </tab-content>
                                    <!-- custom field changes end -->

                                    <tab-content title="Success" ref="tab_contract_success">
                                        <p>Contract information saved successfully!</p>
                                    </tab-content>

                                </form-wizard>
                            </div>
                        </template>
                    </b-card>
                </b-form>
            </div>
            <b-modal id="bv-modal-select-other-components" hide-footer :title="child_popup_title + 's'">


                <b-form @submit.stop.prevent="popupSubmit">

                    <table class="table">
                        <thead>
                            <tr class="table-head">
                                <th>Select</th>
                                <th>Component</th>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-if="child_popup_components">
                                <input type="hidden" name="p_field_key" :value="child_popup_key">
                                <tr class="table-row hover-bg" v-for="ch_popup_data in child_popup_components"
                                    :key="ch_popup_data.id">
                                    <td>
                                        <b-form-group :id="'probation_period-group-' + ch_popup_data.id">
                                            <b-form-checkbox :id="'field_' + ch_popup_data.id"
                                                v-model="child_component_data[ch_popup_data.id]"
                                                :name="'field_' + ch_popup_data.id + '_' + ch_popup_data.field_key"
                                                v-validate="{ required: false }" value="1" unchecked-value="0">
                                                <!--State: <strong>{{ child_component_data[ch_popup_data.id] }}</strong>-->
                                            </b-form-checkbox>
                                        </b-form-group>
                                    </td>
                                    <td>{{ ch_popup_data.field_title }}</td>
                                </tr>
                            </template>
                        </tbody>
                        <tfoot>
                            <tr class="">
                                <td class="px-0" colspan="2">
                                    <div class="d-flex justify-content-center font-weight-bold mt-5">
                                        <!-- Mustafijur: 14-05-2026 -->
                                        <button type="submit" class="btn btn-primary">Save</button>
                                        <!-- Mustafijur: 14-05-2026 -->
                                    </div>
                                </td>
                            </tr>
                        </tfoot>
                    </table>
                </b-form>
            </b-modal>

            <!-- Sohel: New mappings update -->
            <b-modal id="bv-modal-select-cost-center" hide-footer :title="'Add Cost Center'">
                <b-form @submit.stop.prevent="addCostCenterItem">
                    <b-form-group id="cost_center_select-group" label="Cost Center" label-for="cost_center_select"
                        class="required-field">
                        <b-form-select id="cost_center_select" name="cost_center_select" v-model="selectedCostCenter"
                            :options="cost_centers.map(c => ({ value: c.id, text: c.name }))"
                            placeholder="Select Cost Center" v-validate="{ required: true }"
                            :state="validateState('cost_center_select')" aria-describedby="cost_center_select-feedback"
                            data-vv-as="Cost Center"></b-form-select>
                        <b-form-invalid-feedback id="cost_center_select-feedback">
                            {{ veeErrors.first('cost_center_select') }}
                        </b-form-invalid-feedback>
                    </b-form-group>

                    <b-form-group id="cost_center_percentage-group" label="Component Percentage"
                        label-for="cost_center_percentage" class="required-field">
                        <b-form-input id="cost_center_percentage" name="cost_center_percentage" type="text"
                            v-model="componentPercentage" placeholder="Enter component percentage"
                            v-validate="{ required: true, numeric: true, min_value: 0, max_value: 100 }"
                            :state="validateState('cost_center_percentage')"
                            :aria-describedby="'cost_center_percentage-feedback'"
                            data-vv-as="Component Percentage"></b-form-input>
                        <b-form-invalid-feedback id="cost_center_percentage-feedback">
                            {{ veeErrors.first('cost_center_percentage') }}
                        </b-form-invalid-feedback>
                    </b-form-group>

                    <div class="mb-3 text-center">
                        <b-button type="submit" class="">Add Cost Center</b-button>
                    </div>
                </b-form>
            </b-modal>
            <!-- Sohel: New mappings update -->

        </div>
    </b-overlay>
</template>

<style scoped>
.active-bg {
    background-color: #E5FFF9 !important;
}

.custom-info {
    background: #f0f0f0;
    color: #585858;
}

.dashed-border {
    border-bottom: 1px dashed #000;
}

.custom-control-input {
    z-index: 11;
}
</style>

<script>

import { FormWizard, TabContent } from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
export default {

    mounted() {
        this.syncEffectiveDate(); //Contract effective date
    },

    computed: {
        probationDataPairs() {
            let raw = this.salary_settings.probation_data || [];
            let asArray = Array.isArray(raw) ? raw : Object.values(raw);

            let filtered = asArray.filter(
                pb => pb.field_key != 'probation_gross_salary'
            );

            let pairs = [];
            for (let i = 0; i < filtered.length; i += 2) {
                pairs.push(filtered.slice(i, i + 2));
            }
            return pairs;
        }
    },

    props: ['contract_id', 'employee_id'],
    components: {
        FormWizard, TabContent,
    },
    data() {
        return {
            contract: [],
            fdata: [],
            update_contract: 0,
            contract_lists: [],
            review_contract: 0,
            salary_settings: [],
            component_values: [],
            child_component_values: [],
            probation_salary: [],
            child_popup_title: '',
            child_popup_key: '',
            child_popup_components: [],
            child_component_data: [],
            optimize_fields: { house_rent: '0', conveyance_allowance: '0', medical_allowance: '0' },
            skip_optimization: 0,
            status: 1,
            trzsuccess: '',
            trzerrormsg: '',
            errormsg: [],
            loopidxtest: 0,
            successmsg: '',
            contract_action: 'activate',
            other_m_allowence: 0,
            nontaxable_m_allowence: 0,
            contracted_vbenifit_component: 0,
            customized_payroll_report_component: 0,
            customized_payroll_report_probation_component: 0,
            post_gd: 0,
            update_wizard: 0,
            wizard_options: [{ value: 0, text: "Update effective date" }, { value: 1, text: "Salary Information" }, { value: 1, text: "Other monthly allowance" }, { value: 2, text: "Other non-taxable monthly allowance" }, { value: 3, text: "Post-gross deduction" }],
            showoverlay: false,
            last_payslip_date: '',
            last_contract_start_date: '',
            monthNames: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
            pb_salary_fields_editable: 1,
            salary_fields_editable: 1,
            department: [],
            employee_type : [],
            jobposition: [],
            branch: [],
            addons: [],
            leavePolicies: [],
            curr_fiscal_year: '',
            disabled_edit: false,
            form_ajax_validating: false,
            form_ajax_validated: false,
            cost_centers: [],
            //Sohel: New mappings update
            cost_center: [],
            selectedCostCenter: null,
            componentPercentage: 100,
            remainingPercentage: 100,
            //Sohel: New mappings update
            tax_policies: [{ value: 0, text: "Deducted from employee" }, { value: 1, text: "Borne by employer" }],
            /*start gross salary update*/
            custom_gross_components: [],
            custom_probation_gross_components: [],
            /*end gross salary update*/

            /*start non-cash update*/
            accomodation_coverages: [{ value: 1, text: "Partial Accommodation" }, { value: 2, text: "Full Accommodation" }],
            accomodation_coverage: 1,
            perquisite_amount: 0,
            perquisiteIsDisable: true,
            /*end non-cash update*/
            /*start custom field changes*/
            customfieldsdata: [],
            ccdata: [],
            ccfiles: [],
            yes_no: [
                { value: "", text: "Select" },
                { value: "Yes", text: "Yes" },
                { value: "No", text: "No" },

            ],
            /*end custom field changes*/
            sameAsStartDate: true, //Contract effective date

            rosterLeavePolicies: [],

        }
    },

    watch: {
        contract_id() {
            this.loadContractInfo();
        },
        /*Contract effective date Start*/
        'fdata.contract_start'(newVal) {
            if (this.sameAsStartDate) {
                this.fdata.effective_date = newVal;
            }
        }
        /*Contract effective date End*/
    },

    methods: {

        validateState(ref) {
            if (
                this.veeFields[ref] &&
                (this.veeFields[ref].dirty || this.veeFields[ref].validated)
            ) {
                return !this.veeErrors.has(ref);
            }
            return null;
        },

        getChildComponentPairs(components, isProbation) {
            let list = Array.isArray(components) ? components : Object.values(components || {});

            let filtered = list.filter(c => {
                let matchesPrefix = isProbation
                    ? c.field_access_key.indexOf('probation_') === 0
                    : c.field_access_key.indexOf('probation_') !== 0;
                return matchesPrefix && c.status == 1;
            });

            let pairs = [];
            for (let i = 0; i < filtered.length; i += 2) {
                pairs.push(filtered.slice(i, i + 2));
            }
            return pairs;
        },

        moneyFormat(amount) {
            if (amount && parseFloat(amount) > 0) {
                return amount.toLocaleString();
            }
        },


        dateToFiscalYear: function (date_val) {
            let date_obj = new Date(Date.parse(date_val));
            let date_month = date_obj.getMonth();
            let date_year = date_obj.getFullYear();
            let fiscal_data = [];
            date_month = date_month + 1;

            if (date_month > 6) {
                fiscal_data[0] = date_year;
                fiscal_data[1] = date_year + 1;
            }
            else {
                fiscal_data[0] = date_year - 1;
                fiscal_data[1] = date_year;
            }
            return fiscal_data;

        },

        isContractDisabled() {
            return false;
        },

        checkGrossSalary(field_key) {
            var optimize_salary_fields = ['basic_salary', 'house_rent', 'conveyance_allowance', 'medical_allowance'];
            var curr_gross = 0;
            var salary_field_amount = 0;
            var salary_field_value = '';

            /*start gross salary update*/
            if (this.custom_gross_components.length > 0)
                Array.prototype.push.apply(optimize_salary_fields, this.custom_gross_components);
            /*end gross salary update*/

            if (field_key != '' && optimize_salary_fields.includes(field_key)) {
                for (var f_key in optimize_salary_fields) {
                    if (this.component_values[optimize_salary_fields[f_key]]) {

                        salary_field_value = String(this.component_values[optimize_salary_fields[f_key]]);
                        if (salary_field_value)
                            salary_field_amount = Number(salary_field_value.replace(/,/g, ''));
                        else
                            salary_field_amount = 0;

                        curr_gross = curr_gross + salary_field_amount;
                    }
                }
                if (curr_gross > 0)
                    this.fdata.gross = curr_gross;
                this.fdata.gross_display = this.moneyFormat(curr_gross);
            }
        },

        validateFormOverview: function (skip_ajax_validate = false, submit_form = false) {
            let currentObj = this;
            let errors = [];
            let user_dis_name = 'this user';
            if (this.contract.employee_name && this.contract.employee_name.length > 0)
                user_dis_name = this.contract.employee_name;

            if (skip_ajax_validate)
                currentObj.form_ajax_validating = false;

            currentObj.form_ajax_validated = false;

            //if(!this.update_contract){
            //if(!this.fdata.contract_start || (new Date(this.fdata.contract_start) - new Date() < - 86400000 ))
            if (!this.fdata.contract_start)
                errors.push('Please enter a valid contract start date');
            //}

            //Sohel: New mappings update
            if (this.remainingPercentage > 0 && this.remainingPercentage < 100) {
                // errors.push('Total percentage for all Cost Centers can not be less than 100.');
                this.$bvToast.toast('Total percentage for all Cost Centers can not be less than 100.', { title: 'Error!!!', variant: 'danger', solid: true });
                return false;
            }
            //Sohel: New mappings update

            //this.last_payslip_date = '2022-09-30';

            if (this.last_payslip_date.length > 0) {

                let date_payrun = new Date(Date.parse(this.last_payslip_date));
                let date_contract_start = new Date(this.fdata.contract_start);
                let date_contract_end = new Date(this.fdata.contract_end);
                let contract_start_date_error = false;
                //errors.push(date_payrun+date_payrun.getMonth());
                //errors.push('Contract start date can not be prior to '+this.monthNames[date_payrun.getMonth()]+' - '+date_payrun.getFullYear()+' since this company has an Draft / Approved Payrun created until  '+this.monthNames[date_payrun.getMonth()]+' - '+date_payrun.getFullYear());
                let contract_strat_fiscal_year = this.dateToFiscalYear(this.fdata.contract_start);
                let contract_end_fiscal_year = this.dateToFiscalYear(this.fdata.contract_end);

                let curr_fiscal_yr = this.curr_fiscal_year.split("-");
                let curr_fiscal_segment1 = curr_fiscal_yr[0];
                let curr_fiscal_segment2 = curr_fiscal_yr[1];

                if (contract_strat_fiscal_year[0] >= curr_fiscal_segment1 && contract_strat_fiscal_year[1] >= curr_fiscal_segment2) {
                    currentObj.form_ajax_validating = false;
                    //alert('if');
                    if (date_contract_start.getFullYear() < date_payrun.getFullYear())
                        contract_start_date_error = true;
                    else if (date_contract_start.getFullYear() == date_payrun.getFullYear()) {
                        if (date_contract_start.getMonth() <= date_payrun.getMonth())
                            contract_start_date_error = true;
                    }

                    if (contract_start_date_error)
                        errors.push('Contract start date can not be prior to ' + this.monthNames[date_payrun.getMonth()] + ' - ' + date_payrun.getFullYear() + ' since ' + user_dis_name + ' has an Draft / Approved Payslip created under  ' + this.monthNames[date_payrun.getMonth()] + ' - ' + date_payrun.getFullYear() + ' Payrun.');
                } else {
                    //alert('else if');
                    /*if(this.fdata.contract_end == '' || contract_end_fiscal_year[0]>= curr_fiscal_segment1 || contract_end_fiscal_year[1]>= curr_fiscal_segment2){
                       errors.push('Contract end date should be a vaild date and need to end before current fiscal year');
                    }*/
                    if (this.last_contract_start_date != '' || this.last_contract_start_date != '0000-00-00') {
                        //if(this.fdata.contract_end == '' || contract_end_fiscal_year[0]>= curr_fiscal_segment1 || contract_end_fiscal_year[1]>= curr_fiscal_segment2){
                        //errors.push('Contract end date should be a vaild date and need to end before current fiscal year');
                        //}
                        if (!skip_ajax_validate) {
                            this.form_ajax_validating = true;
                            this.showoverlay = true;

                            let validatedata = new FormData();
                            validatedata.append('contract_start', this.fdata.contract_start);
                            validatedata.append('contract_end', this.fdata.contract_end);

                            axios.post(this.$api_url + '/contract/datevalidate', validatedata)
                                .then(function (response) {

                                    if (response.data.success) {
                                        currentObj.form_ajax_validating = false;
                                        currentObj.form_ajax_validated = true;
                                        if (submit_form) {
                                            currentObj.showoverlay = false;
                                            currentObj.$refs.save_finish.click();
                                            return false;
                                        }

                                        currentObj.moveNext('1', true);
                                        currentObj.showoverlay = false;

                                    } else {
                                        let err_show = '';
                                        if (response.data.errormsg)
                                            err_show = response.data.errormsg;
                                        else
                                            err_show = "Server error!!!";

                                        currentObj.showoverlay = false;

                                        this.$bvToast.toast(err_show, {
                                            title: 'Error',
                                            variant: 'danger',
                                            solid: true
                                        });
                                    }

                                }.bind(this))
                                .catch(function (error) {
                                    this.$bvToast.toast(error.response.data.errors, {
                                        title: 'Error',
                                        variant: 'danger',
                                        solid: true
                                    });
                                    currentObj.showoverlay = false;
                                });



                        }

                    }
                }

            }


            if (this.fdata.contract_end && (new Date(this.fdata.contract_end) < new Date(this.fdata.contract_start))) {
                errors.push('Contract end date should be greater than contract start date');
            }

            if (parseInt(this.fdata.has_probation) == 1) {
                if (!this.fdata.probation_start)
                    errors.push('Please enter probation period start date');
                else if (new Date(this.fdata.probation_start) < new Date(this.fdata.contract_start)) {
                    errors.push('Probation period start date cannot be before contract start date');
                }

                if (this.fdata.pb_optimized_salary_for_max_benefit != 0 && this.fdata.pb_optimized_salary_for_max_benefit != 1)
                    errors.push('Please select whether you want to optimize salary or enter manually');

                if (!this.validateProbationSalaryFields())
                    return false;


            }






            if (errors.length > 0) {
                this.$bvToast.toast(errors[0], { title: 'Error!!!', variant: 'danger', solid: true });
                return false;
            }
            else
                return true;
        },

        loadWizard: function () {
            this.$refs.wizard.changeTab(0, this.update_wizard);
        },
        moveNext: function (step = '', skip_ajax_validate = false) {
            /*this.$bvToast.toast("Step: "+step, {title: 'Error!',variant: 'danger',solid: true});*/
            if (step == '1') {
                //Sohel: New mappings update
                /* if(this.remainingPercentage > 0 && this.remainingPercentage < 100){
                  this.$bvToast.toast('Total percentage for all Cost Centers can not be less than 100.', {title: 'Error!!!',variant: 'danger',solid: true});
                  return false;
                } */
                //Sohel: New mappings update
                if (this.validateFormOverview(skip_ajax_validate)) {
                    if (!this.form_ajax_validating)
                        this.$refs.wizard.nextTab();
                }
            } else if (step == '2') {
                if (this.validateSalaryFields())
                    this.$refs.wizard.nextTab();
            } else {
                this.$refs.wizard.nextTab();
            }
        },
        goBack: function () {
            this.$refs.wizard.prevTab();
        },


        onComplete: function () {

            /*this.$bvToast.toast('Yay. Done!', {
                                        title: `All steps completed`,
                                        variant: 'success',
                                        solid: true
                                    });


            location.reload(); */

            //this.$refs.wizard.submit();
        },
        /*start gross salary update*/
        resetCustomGrossFields(probation = true) {
            let component_fields = probation ? this.custom_probation_gross_components : this.custom_gross_components;

            if (component_fields.length > 0) {
                for (var f_key in component_fields) {
                    if (probation)
                        this.probation_salary[component_fields[f_key]] = null;
                    else
                        this.component_values[component_fields[f_key]] = null;
                }
            }
        },

        /*end gross salary update*/
        checkProbationGrossSalary(field_key) {
            var optimize_salary_fields = ['probation_basic_salary', 'probation_house_rent', 'probation_conveyance_allowance', 'probation_medical_allowance'];
            var curr_gross = 0;
            var prob_field_amount = 0;
            var prob_field_value = '';

            //alert(field_key);

            /*start gross salary update*/
            if (this.custom_probation_gross_components.length > 0)
                Array.prototype.push.apply(optimize_salary_fields, this.custom_probation_gross_components);
            /*end gross salary update*/
            if (field_key != '' && optimize_salary_fields.includes(field_key)) { /*gross salary update*/
                for (var f_key in optimize_salary_fields) {
                    if (this.probation_salary[optimize_salary_fields[f_key]] && f_key != 'probation_gross_salary') {
                        prob_field_value = String(this.probation_salary[optimize_salary_fields[f_key]]);
                        if (prob_field_value)
                            prob_field_amount = Number(prob_field_value.replace(/,/g, ''));
                        else
                            prob_field_amount = 0;


                        //alert(f_key + ': '+prob_field_value);
                        curr_gross = curr_gross + prob_field_amount;
                    }
                }
                if (curr_gross > 0)
                    this.probation_salary['probation_gross_salary'] = curr_gross;
            }
        },
        setChildComponents(parent_key, child_data) {
            //console.log("parent_key");
            if (parent_key && child_data) {
                //console.log(parent_key);
                this.child_component_values[parent_key] = child_data;
                for (var c_data in child_data) {

                    this.component_values[child_data[c_data].field_key] = this.moneyFormat(child_data[c_data].field_value);
                    if (parent_key == 'other_monthly_allowance' && parseFloat(child_data[c_data].field_value) > 0)
                        this.other_m_allowence = 1;
                    else if (parent_key == 'other_non_taxable_monthly_allowance' && parseFloat(child_data[c_data].field_value) > 0)
                        this.nontaxable_m_allowence = 1;
                    else if (parent_key == 'other_post_gross_deduction' && parseFloat(child_data[c_data].field_value) > 0)
                        this.post_gd = 1;
                    else if (parent_key == 'contracted_variable_benefits' && parseFloat(child_data[c_data].field_value) > 0)
                        this.contracted_vbenifit_component = 1;
                    else if (parent_key == 'customized_payroll_report' && parseFloat(child_data[c_data].field_value) > 0) {
                        if (child_data[c_data].field_access_key.indexOf('probation_') === 0)
                            this.customized_payroll_report_probation_component = 1;
                        else
                            this.customized_payroll_report_component = 1;

                    }

                }
            }
        },
        setComponentValues: function () {
            //this.loopidxtest++;
            //console.log('setComponentValues call '+this.loopidxtest);

            if (this.salary_settings.fixed.length > 0) {
                var optimize_fields_array = ['house_rent', 'conveyance_allowance', 'medical_allowance'];

                for (var c_data in this.salary_settings.fixed) {
                    if (parseInt(this.salary_settings.fixed[c_data].date_range) != 1)
                        this.component_values[this.salary_settings.fixed[c_data].field_name] = this.moneyFormat(this.salary_settings.fixed[c_data].field_value);
                    else
                        this.component_values[this.salary_settings.fixed[c_data].field_name] = this.salary_settings.fixed[c_data].is_checked;

                    if (optimize_fields_array.includes(this.salary_settings.fixed[c_data].field_name))
                        this.optimize_fields[this.salary_settings.fixed[c_data].field_name] = '1';

                    /*start gross salary update*/
                    if (this.salary_settings.fixed[c_data].field_key.indexOf('custom_gross_salary_') === 0)
                        this.custom_gross_components.push(this.salary_settings.fixed[c_data].field_key);
                    /*end gross salary update*/

                    if (parseInt(this.salary_settings.fixed[c_data].section_only) > 0) {
                        if (this.salary_settings.fixed[c_data].child_components)
                            this.setChildComponents(this.salary_settings.fixed[c_data].field_name, this.salary_settings.fixed[c_data].child_components);
                    }
                }
            }

            if (this.salary_settings.fixed_deduction.length > 0) {
                for (var m_data in this.salary_settings.fixed_deduction) {

                    this.component_values[this.salary_settings.fixed_deduction[m_data].field_name] = this.moneyFormat(this.salary_settings.fixed_deduction[m_data].field_value);
                    if (parseInt(this.salary_settings.fixed_deduction[m_data].section_only) > 0) {
                        if (this.salary_settings.fixed_deduction[m_data].child_components)
                            this.setChildComponents(this.salary_settings.fixed_deduction[m_data].field_name, this.salary_settings.fixed_deduction[m_data].child_components);
                    }
                }
            }
            //console.log('Comes here');
            if (this.salary_settings.reserved_data) {
                //console.log('Enter Comes here');
                for (var r_data in this.salary_settings.reserved_data) {
                    if (!this.salary_settings.reserved_data[r_data].start) {
                        if (this.salary_settings.reserved_data[r_data].field_key) {

                            if (this.salary_settings.reserved_data[r_data].field_key.indexOf("_date") > 0) {
                                if (this.salary_settings.reserved_data[r_data].field_value != '0000-00-00')
                                    this.component_values[this.salary_settings.reserved_data[r_data].field_key] = this.salary_settings.reserved_data[r_data].field_value;
                                else
                                    this.component_values[this.salary_settings.reserved_data[r_data].field_key] = "";
                            } else {
                                this.component_values[this.salary_settings.reserved_data[r_data].field_key] = this.moneyFormat(this.salary_settings.reserved_data[r_data].field_value);
                            }
                        }//console.log('Field Key: '+this.salary_settings.reserved_data[r_data].field_key+', Field Value: '+this.salary_settings.reserved_data[r_data].field_value);
                        //console.log(this.salary_settings.reserved_data[r_data].field_key);
                        if (this.salary_settings.reserved_data[r_data].field_key == 'rent_free_accommodation_start_date' && this.salary_settings.reserved_data[r_data].field_value != '')
                            this.component_values['rent_free_accommodation'] = 1;
                        /*else if(this.salary_settings.reserved_data[r_data].field_key =='conveyance_personal_private_cars_upto_2500_cc' || this.salary_settings.reserved_data[r_data].field_key =='conveyance_personal_private_cars_above_2500_cc'){
                           if(this.salary_settings.reserved_data[r_data].field_value !='')
                           this.component_values['conveyance_personal_private'] = 1;
                        }*/


                    }
                }
                this.fdata.gross = this.moneyFormat(this.salary_settings.reserved_data.gross_salary.field_value);
                this.fdata.gross_display = this.moneyFormat(this.salary_settings.reserved_data.gross_salary.field_value);
                this.fdata.rental_amount = this.moneyFormat(this.salary_settings.reserved_data.rental_amount.field_value);

                let conveyance_enable = false;
                if (this.component_values['conveyance_personal_private'] !== undefined && this.component_values['conveyance_personal_private'] == 1)
                    conveyance_enable = true;

                //this.fdata.conveyance_personal_private_cars_upto_2500_cc =  (conveyance_enable && this.salary_settings.reserved_data.conveyance_personal_private_cars_upto_2500_cc) ? this.moneyFormat(this.salary_settings.reserved_data.conveyance_personal_private_cars_upto_2500_cc.field_value): 0;

                //  New slabs for conveyance personal/private related updates: Sohel

                this.fdata.conveyance_personal_private_cars_upto_1500_cc = (conveyance_enable && this.salary_settings.reserved_data.conveyance_personal_private_cars_upto_1500_cc) ? this.moneyFormat(this.salary_settings.reserved_data.conveyance_personal_private_cars_upto_1500_cc.field_value) : 0;

                this.fdata.conveyance_personal_private_cars_1501_to_2000_cc = (conveyance_enable && this.salary_settings.reserved_data.conveyance_personal_private_cars_1501_to_2000_cc) ? this.moneyFormat(this.salary_settings.reserved_data.conveyance_personal_private_cars_1501_to_2000_cc.field_value) : 0;

                this.fdata.conveyance_personal_private_cars_2001_to_2500_cc = (conveyance_enable && this.salary_settings.reserved_data.conveyance_personal_private_cars_2001_to_2500_cc) ? this.moneyFormat(this.salary_settings.reserved_data.conveyance_personal_private_cars_2001_to_2500_cc.field_value) : 0;

                //  New slabs for conveyance personal/private related updates: Sohel

                this.fdata.conveyance_personal_private_cars_above_2500_cc = (conveyance_enable && this.salary_settings.reserved_data.conveyance_personal_private_cars_above_2500_cc) ? this.moneyFormat(this.salary_settings.reserved_data.conveyance_personal_private_cars_above_2500_cc.field_value) : 0;

                this.fdata.tax_policy = (this.salary_settings.reserved_data.tax_policy && this.salary_settings.reserved_data.tax_policy.field_value != "") ? this.salary_settings.reserved_data.tax_policy.field_value : 0;
            }

            if (this.salary_settings.probation_data) {
                //console.log('Enter Comes here');
                for (var p_data in this.salary_settings.probation_data) {
                    if (this.salary_settings.probation_data[p_data].field_key) {  /*gross salary update*/
                        this.probation_salary[this.salary_settings.probation_data[p_data].field_key] = this.moneyFormat(this.salary_settings.probation_data[p_data].field_value);
                        /*start gross salary update*/
                        if (this.salary_settings.probation_data[p_data].field_key.indexOf('probation_custom_gross_salary_') >= 0)
                            this.custom_probation_gross_components.push(this.salary_settings.probation_data[p_data].field_key);
                        /*end gross salary update*/
                        //console.log('Field Key: '+this.salary_settings.probation_data[p_data].field_key+', Field Value: '+this.salary_settings.probation_data[p_data].field_value);
                    } /*gross salary update*/
                }
            }

            if (this.salary_settings.contracted_variable_benefits.length > 0) {
                for (var vb_data in this.salary_settings.contracted_variable_benefits) {

                    this.component_values[this.salary_settings.contracted_variable_benefits[vb_data].field_name] = this.moneyFormat(this.salary_settings.contracted_variable_benefits[vb_data].field_value);
                    if (parseInt(this.salary_settings.contracted_variable_benefits[vb_data].section_only) > 0) {
                        if (this.salary_settings.contracted_variable_benefits[vb_data].child_components)
                            this.setChildComponents(this.salary_settings.contracted_variable_benefits[vb_data].field_name, this.salary_settings.contracted_variable_benefits[vb_data].child_components);
                    }
                }
            }

            if (this.salary_settings.customized_payroll_report && this.salary_settings.customized_payroll_report.length > 0) {
                for (var cp_data in this.salary_settings.customized_payroll_report) {

                    this.component_values[this.salary_settings.customized_payroll_report[cp_data].field_name] = this.moneyFormat(this.salary_settings.customized_payroll_report[cp_data].field_value);
                    if (parseInt(this.salary_settings.customized_payroll_report[cp_data].section_only) > 0) {
                        if (this.salary_settings.customized_payroll_report[cp_data].child_components)
                            this.setChildComponents(this.salary_settings.customized_payroll_report[cp_data].field_name, this.salary_settings.customized_payroll_report[cp_data].child_components);
                    }
                }
            }

        },


        getContractLists: function () {

            axios.get(this.$api_url + '/allcontracts', {
                params: {
                }
            }).then(function (response) {
                this.contract_lists = response.data.data;
                //console.log(response.data.data);
            }.bind(this))
                .catch(function (error) {
                    currentObj.errormsg = error.response.data.errors;
                });
        },

        getSalarySettings: function () {
            axios.get(this.$api_url + '/employeesalarysettings/' + this.contract.employee_id + '/' + this.contract.id, {
                params: {
                }
            }).then(function (response) {
                this.salary_settings = response.data.data;
                this.setComponentValues();
                this.triggerRentalAmountChange(); /*non-cash update*/
            }.bind(this));
        },
        selectChildComponents(fieldKey, filedTitle) {


            //console.log(fieldKey);
            //console.log(filedTitle);
            //console.log(this.child_component_values);

            if (this.child_component_values[fieldKey]) {
                var child_comp_val = 0;
                for (var ch_data in this.child_component_values[fieldKey]) {
                    child_comp_val = parseInt(this.child_component_values[fieldKey][ch_data].is_checked) ? 1 : 0;
                    this.child_component_data[this.child_component_values[fieldKey][ch_data].id] = child_comp_val;
                }
                this.child_popup_title = filedTitle;
                this.child_popup_components = this.child_component_values[fieldKey];
                this.child_popup_key = fieldKey;
                this.$root.$emit('bv::show::modal', 'bv-modal-select-other-components');
            } else {
                this.$bvToast.toast("Please add component field for '" + filedTitle + "' from company settings.", {
                    title: 'No components available',
                    variant: 'danger',
                    solid: true
                });
            }

        },

        setDateRangeValue(tKey, currVal) {

            if (parseInt(currVal) == 0) {
                this.component_values[tKey + '_start_date'] = '';
                this.component_values[tKey + '_end_date'] = '';
            }

        },

        triggerGrossChange() {
            if (this.fdata.optimized_salary_for_max_benefit == 1) {
                this.optimizeSalary(1);
            }
        },
        triggerProbationGrossChange() {
            if (this.fdata.pb_optimized_salary_for_max_benefit == 1) {
                this.optimizeProbationSalary(1);
            }
        },


        optimizeSalary(cVal) {
            this.salary_fields_editable = 0;
            if (parseInt(cVal) == 1) {
                this.resetCustomGrossFields(false); /*gross salary update*/

                var gross_amount = Number(String(this.fdata.gross).replace(/,/g, ''));

                if (parseInt(gross_amount) < 999 || !gross_amount) {
                    //this.errormsg['0'] = ["Enter valid gross salary"];
                    this.$bvToast.toast("Please enter valid gross salary", {
                        title: 'Error!',
                        variant: 'danger',
                        solid: true
                    });
                } else {
                    let currentObj = this;
                    this.errormsg.splice(0, 1);
                    //console.log("Optimize Salary Fields: House Rent => " +this.optimize_fields.house_rent+" Conveyance => "+this.optimize_fields.conveyance_allowance+" Medical => "+this.optimize_fields.medical_allowance);
                    const config = {
                        headers: { 'content-type': 'multipart/form-data' }
                    }
                    if (parseInt(this.optimize_fields.house_rent) || parseInt(this.optimize_fields.conveyance_allowance) || parseInt(this.optimize_fields.medical_allowance)) {
                        let formData = new FormData();

                        formData.append('gross_salary', gross_amount);
                        formData.append('medical', this.optimize_fields.medical_allowance);
                        formData.append('conv', this.optimize_fields.conveyance_allowance);
                        formData.append('hra', this.optimize_fields.house_rent);



                        axios.post(this.$api_url + '/optimizesalary', formData, config)
                            .then(function (response) {
                                if (response.data.data) {
                                    for (var res_data in response.data.data) {
                                        if (response.data.data[res_data]) {
                                            this.component_values[res_data] = this.moneyFormat(response.data.data[res_data]);
                                            this.$set(this.component_values, 0, true);
                                        }
                                    }
                                }
                            }.bind(this))
                            .catch(function (error) {
                                currentObj.errormsg = error.response.data.errors;
                            });


                    }
                    else {
                        this.$bvToast.toast("For salary optimization you have to enable at lease 1 field from 'House Rent Allowance/Conveyance Allowance/Medical Allowance' in 'Company Salary Settings'", {
                            title: 'Error!',
                            variant: 'danger',
                            solid: true
                        });
                    }
                }
            }
            else
                this.errormsg.splice(0, 1);
        },

        optimizeProbationSalary(cVal) {

            this.pb_salary_fields_editable = 0;
            if (parseInt(cVal) == 1) {
                this.resetCustomGrossFields(); /*gross salary update*/

                var probation_feild_value = String(this.probation_salary['probation_gross_salary']);
                var probation_gross_amount = Number(probation_feild_value.replace(/,/g, ''));



                if (parseInt(probation_gross_amount) < 999 || !probation_gross_amount) {
                    this.$bvToast.toast("Please enter valid probation gross salary", {
                        title: 'Error!',
                        variant: 'danger',
                        solid: true
                    });
                } else {
                    let currentObj = this;
                    this.errormsg.splice(0, 1);
                    const config = {
                        headers: { 'content-type': 'multipart/form-data' }
                    }
                    if (parseInt(this.optimize_fields.house_rent) || parseInt(this.optimize_fields.conveyance_allowance) || parseInt(this.optimize_fields.medical_allowance)) {
                        let formData = new FormData();

                        formData.append('gross_salary', probation_gross_amount);
                        formData.append('medical', this.optimize_fields.medical_allowance);
                        formData.append('conv', this.optimize_fields.conveyance_allowance);
                        formData.append('hra', this.optimize_fields.house_rent);

                        axios.post(this.$api_url + '/optimizesalary', formData, config)
                            .then(function (response) {
                                if (response.data.data) {
                                    for (var res_data in response.data.data) {
                                        if (response.data.data[res_data]) {
                                            this.probation_salary['probation_' + res_data] = this.moneyFormat(response.data.data[res_data]);
                                            this.$set(this.probation_salary, 0, true);
                                            this.$delete(this.probation_salary, 0);
                                        }
                                    }
                                }
                            }.bind(this))
                            .catch(function (error) {
                                currentObj.errormsg = error.response.data.errors;
                            });


                    }
                    else {
                        this.$bvToast.toast("For salary optimization you have to enable at lease 1 field from 'House Rent Allowance/Conveyance Allowance/Medical Allowance' in 'Company Salary Settings'", {
                            title: 'Error!',
                            variant: 'danger',
                            solid: true
                        });
                    }
                }
            }
            else
                this.errormsg.splice(0, 1);
        },

        initializeContractDates: function () {
            if (this.contract.probation_start == '0000-00-00')
                this.fdata.probation_start = '';
            if (this.contract.probation_end == '0000-00-00')
                this.fdata.probation_end = '';
            if (this.contract.contract_start == '0000-00-00')
                this.fdata.contract_start = '';
            if (this.contract.contract_end == '0000-00-00')
                this.fdata.contract_end = '';
        },

        addNewContract: function () {

            axios.get(this.$api_url + '/addcontract/' + this.contract.employee_id, {
                params: {
                }
            }).then(function (response) {
                if (response.data.contract_id) {
                    window.location.href = this.$api_url + '/contract/' + this.contract.employee_id + '/' + response.data.contract_id;
                }

            }.bind(this));
        },

        popupSubmit(e) {
            e.preventDefault();
            let currentObj = this;
            const config = {
                headers: { 'content-type': 'multipart/form-data' }
            }
            let formData = new FormData();

            let request_data = null;
            let submit_data = false;

            for (let item in e.target) {

                if (e.target.hasOwnProperty(item)) {
                    const record = e.target[item];
                    if (record.name) {
                        if (record.name == 'p_field_key')
                            formData.append(record.name, record.value);
                        else {
                            request_data = record.checked ? 1 : 0;
                            formData.append(record.name, request_data);
                            submit_data = true;
                        }
                    }
                }
            }
            if (submit_data) {

                formData.append('employee_id', this.contract.employee_id);
                formData.append('contract_id', this.contract.id);

                axios.post(this.$api_url + '/savechildcomponents', formData, config)
                    .then(function (response) {
                        if (response.data.data) {
                            for (var f_key in response.data.data) {
                                if (f_key) {
                                    for (var f_id in response.data.data[f_key]) {
                                        this.child_component_values[f_key][f_id].is_checked = response.data.data[f_key][f_id].is_checked;
                                    }
                                }
                            }

                            this.$root.$emit('bv::hide::modal', 'bv-modal-select-other-components');
                        }
                    }.bind(this))
                    .catch(function (error) {
                        currentObj.errormsg = error.response.data.errors;
                    });
            }

        },


        loadContractInfo() {
            //console.log('Here is contract id'+this.contract_id);
            if (parseInt(this.contract_id) > 0) {
                this.showoverlay = true;
                this.update_contract = this.contract_id;
                axios.get(this.$api_url + '/getcontractinfo/' + this.contract_id, {
                    params: {
                    }
                }).then(function (response) {
                    if (response.data.data) {
                        this.contract = response.data.data;
                        this.fdata = response.data.data;
                        this.getSalarySettings();
                        this.getContractCustomData(); /*custom field changes*/
                        this.initializeContractDates();
                        this.fdata.pb_optimized_salary_for_max_benefit = 0;
                        this.fdata.optimized_salary_for_max_benefit = 0;
                        this.cost_center = this.contract.cost_center_id; /*Contract wizard cost center update*/
                        //Sohel: New mappings update
                        const usedPercentage = this.cost_center.reduce(
                            (sum, c) => sum + Number(c.component_percentage),
                            0
                        );
                        const remainingPercentage = 100 - usedPercentage;
                        this.remainingPercentage = remainingPercentage;
                        //Sohel: New mappings update
                        this.showoverlay = false;
                    }
                }.bind(this));

            } else {
                this.showoverlay = true;
                axios.get(this.$api_url + '/getnewcontract', {
                    params: {
                        employee_id: this.employee_id
                    }
                }).then(function (response) {
                    if (response.data.data) {
                        this.contract = response.data.data;
                        this.fdata = response.data.data;
                        this.getSalarySettings();
                        this.getContractCustomData(); /*custom field changes*/
                        this.initializeContractDates();
                        this.cost_center = this.contract.cost_center_id; /*Contract wizard cost center update*/
                        //Sohel: New mappings update
                        const usedPercentage = this.cost_center.reduce(
                            (sum, c) => sum + Number(c.component_percentage),
                            0
                        );
                        const remainingPercentage = 100 - usedPercentage;
                        this.remainingPercentage = remainingPercentage;
                        //Sohel: New mappings update
                        this.showoverlay = false;
                    }
                }.bind(this));
            }
        },


        loadGeneralSettings() {
            axios.get(this.$api_url + '/get_employee_last_payslip_date', {
                params: {
                }
            }).then(function (response) {
                //alert();
                //console.log(response.data);
                if (response.data) {
                    this.last_payslip_date = response.data;
                } else {
                    this.last_payslip_date = '';
                }

            }.bind(this));


            axios.get(this.$api_url + '/employee-last-contract-start-date', {
                params: {
                }
            }).then(function (response) {
                //alert();
                //console.log(response.data);
                if (response.data) {
                    this.last_contract_start_date = response.data;
                    //alert(this.last_contract_start_date);
                } else {
                    this.last_contract_start_date = '';
                }

            }.bind(this));

        },
        triggerNewContract() {
            this.review_contract = 0;
            this.skip_optimization = 0;
            axios.get(this.$api_url + '/getnewcontract', {
                params: {
                    employee_id: this.employee_id
                }
            }).then(function (response) {
                if (response.data.data) {
                    this.contract = response.data.data;
                    this.fdata = response.data.data;
                    this.getSalarySettings();
                    this.initializeContractDates();
                }
            }.bind(this));
        },

        triggerContractArchive() {
            this.review_contract = 0;
        },

        triggerFormatData(val) {
            //alert("here"+val);
        },

        /*start non-cash update*/
        triggerRentalAmountChange() {
            if (this.accomodation_coverage == 2) {
                this.fdata.rent_paid_by_employee = 0;
                this.perquisite_amount = this.fdata.rental_amount;
            } else {
                if (!this.fdata.rent_paid_by_employee)
                    this.fdata.rent_paid_by_employee = 0;
            }

            let rental_amount = this.fdata.rental_amount ? Number(this.fdata.rental_amount.replace(/,/g, '')) : 0;
            let rent_paid_by_employee = this.fdata.rent_paid_by_employee ? Number(this.fdata.rent_paid_by_employee.replace(/,/g, '')) : 0;

            if (rental_amount < 0) {
                this.$bvToast.toast("Monthly Rental Amount must be greater than zero", { title: 'Error!', variant: 'danger', solid: true });
                this.fdata.rental_amount = 0;
                this.fdata.rent_paid_by_employee = 0;
                rental_amount = 0;
                rent_paid_by_employee = 0;
            }

            if (rent_paid_by_employee < 0) {
                this.$bvToast.toast("Rent Paid by Employee must be greater than zero", { title: 'Error!', variant: 'danger', solid: true });
                this.fdata.rent_paid_by_employee = 0;
                rent_paid_by_employee = 0;
            }

            if (rental_amount > 0 && rent_paid_by_employee >= rental_amount) {
                this.$bvToast.toast("Rent Paid by the Employee can never be greater than or equal to the Monthly Rental Amount", { title: 'Error!', variant: 'danger', solid: true });
                this.fdata.rent_paid_by_employee = 0;
                rent_paid_by_employee = 0;
            }

            if (!rent_paid_by_employee)
                rent_paid_by_employee = 0;


            this.perquisite_amount = rental_amount - rent_paid_by_employee;


            //alert(this.fdata.rental_amount);
        },

        /*end non-cash update*/


        validateSalaryFields() {
            var optimize_salary_fields = ['basic_salary', 'house_rent', 'conveyance_allowance', 'medical_allowance'];
            var curr_gross = 0;

            if (!Number(String(this.fdata.gross).replace(/,/g, ''))) {
                this.$bvToast.toast("Please enter valid Gross Salary", { title: 'Error!', variant: 'danger', solid: true });
                return false;
            }

            if (this.fdata.optimized_salary_for_max_benefit != 0 && this.fdata.optimized_salary_for_max_benefit != 1) {
                this.$bvToast.toast("Please select whether you want to optimize salary or enter manually", { title: 'Error!', variant: 'danger', solid: true });
                return false;
            }

            /*start gross salary update*/
            if (this.custom_gross_components.length > 0)
                Array.prototype.push.apply(optimize_salary_fields, this.custom_gross_components);
            /*end gross salary update*/

            for (var f_key in optimize_salary_fields) {
                if (this.component_values[optimize_salary_fields[f_key]]) {
                    curr_gross = curr_gross + Number(String(this.component_values[optimize_salary_fields[f_key]]).replace(/,/g, ''));
                }
            }
            if (Number(String(this.fdata.gross).replace(/,/g, '')) != parseFloat(curr_gross)) {
                this.$bvToast.toast("Total Salary " + curr_gross + " not equal to Gross Salary " + this.fdata.gross, { title: 'Error!', variant: 'danger', solid: true });
                return false;
            } else {
                if (this.customized_payroll_report_component == 1) {
                    let cp_heads_total = 0;
                    let cp_head_val = 0;

                    if (this.salary_settings.customized_payroll_report.length > 0) {
                        for (var cpr_data in this.salary_settings.customized_payroll_report) {
                            for (var cpr_child_data in this.salary_settings.customized_payroll_report[cpr_data].child_components) {
                                //console.log(this.salary_settings.customized_payroll_report[cpr_data].child_components[cpr_child_data]);
                                if (this.salary_settings.customized_payroll_report[cpr_data].child_components[cpr_child_data].status == 1 && this.salary_settings.customized_payroll_report[cpr_data].child_components[cpr_child_data].field_access_key.indexOf('probation_') !== 0) {
                                    //alert(this.component_values[this.salary_settings.customized_payroll_report[cpr_data].child_components[cpr_child_data].field_key]);
                                    cp_head_val = Number(String(this.component_values[this.salary_settings.customized_payroll_report[cpr_data].child_components[cpr_child_data].field_key]).replace(/,/g, ''));
                                    if (cp_head_val > 0)
                                        cp_heads_total = cp_heads_total + cp_head_val;

                                }
                            }
                        }

                        if (cp_heads_total <= 0) {
                            this.$bvToast.toast("Customized heads amount can not be empty and total should match the gross salary ", { title: 'Error!', variant: 'danger', solid: true });
                            return false;
                        }

                        if (Number(String(this.fdata.gross).replace(/,/g, '')) != cp_heads_total) {
                            this.$bvToast.toast("Customized heads total  " + this.moneyFormat(cp_heads_total) + " is not equal to Gross Salary " + this.fdata.gross, { title: 'Error!', variant: 'danger', solid: true });
                            return false;
                        }

                    }

                }
                return true;
            }
        },
        validateProbationSalaryFields() {
            var optimize_probation_salary_fields = ['probation_basic_salary', 'probation_house_rent', 'probation_conveyance_allowance', 'probation_medical_allowance'];

            /*start gross salary update*/
            if (this.custom_probation_gross_components.length > 0)
                Array.prototype.push.apply(optimize_probation_salary_fields, this.custom_probation_gross_components);
            /*end gross salary update*/

            var p_curr_gross = 0;

            if (this.fdata.has_probation == 1) {
                if (!Number(String(this.probation_salary['probation_gross_salary']).replace(/,/g, ''))) {
                    this.$bvToast.toast("Please enter a valid Probation Gross Salary", { title: 'Error!', variant: 'danger', solid: true });
                    return false;
                }
            }

            if (this.fdata.has_probation == 1) {
                for (var pf_key in optimize_probation_salary_fields) {
                    if (this.probation_salary[optimize_probation_salary_fields[pf_key]]) {
                        p_curr_gross = p_curr_gross + Number(String(this.probation_salary[optimize_probation_salary_fields[pf_key]]).replace(/,/g, ''));
                    }
                }
                if (Number(String(this.probation_salary['probation_gross_salary']).replace(/,/g, '')) != parseFloat(p_curr_gross)) {
                    this.$bvToast.toast("Total Probation Salary " + p_curr_gross + " is not equal to Probation Gross Salary " + this.probation_salary['probation_gross_salary'], { title: 'Error!', variant: 'danger', solid: true });
                    return false;
                }

                if (this.customized_payroll_report_probation_component == 1) {
                    let cp_prb_heads_total = 0;
                    let cp_prb_head_val = 0;

                    if (this.salary_settings.customized_payroll_report.length > 0) {
                        for (var cpr_data in this.salary_settings.customized_payroll_report) {
                            for (var cpr_child_data in this.salary_settings.customized_payroll_report[cpr_data].child_components) {
                                //console.log(this.salary_settings.customized_payroll_report[cpr_data].child_components[cpr_child_data]);
                                if (this.salary_settings.customized_payroll_report[cpr_data].child_components[cpr_child_data].status == 1 && this.salary_settings.customized_payroll_report[cpr_data].child_components[cpr_child_data].field_access_key.indexOf('probation_') === 0) {
                                    //alert(this.component_values[this.salary_settings.customized_payroll_report[cpr_data].child_components[cpr_child_data].field_key]);
                                    cp_prb_head_val = Number(String(this.component_values[this.salary_settings.customized_payroll_report[cpr_data].child_components[cpr_child_data].field_key]).replace(/,/g, ''));
                                    if (cp_prb_head_val > 0)
                                        cp_prb_heads_total = cp_prb_heads_total + cp_prb_head_val;

                                }
                            }
                        }

                        if (cp_prb_heads_total <= 0) {
                            this.$bvToast.toast("Customized heads amount can not be empty and total should match the probation gross salary ", { title: 'Error!', variant: 'danger', solid: true });
                            return false;
                        }

                        if (Number(String(this.probation_salary['probation_gross_salary']).replace(/,/g, '')) != cp_prb_heads_total) {
                            this.$bvToast.toast("Customized heads total  " + this.moneyFormat(cp_prb_heads_total) + " is not equal to Probation Gross Salary " + this.probation_salary['probation_gross_salary'], { title: 'Error!', variant: 'danger', solid: true });
                            return false;
                        }

                    }
                }


            }
            return true;
        },

        saveContractData(formData, config) {
            let currentObj = this;
            axios.post(this.$api_url + '/savecontract', formData, config)
                .then(function (response) {
                    currentObj.successmsg = response.data.message;
                    if (response.data.success) {
                        /*this.$bvToast.toast(response.data.message, {
                                title: 'Success',
                                variant: 'success',
                                solid: true
                            });*/
                        //this.getContractLists();
                        this.$emit('event', 'success');
                        this.$refs.wizard.changeTab(0, 6); /* custom field changes*/

                    } else if (response.data.error && response.data.message) {
                        this.$bvToast.toast(response.data.message, {
                            title: 'Error',
                            variant: 'danger',
                            solid: true
                        });
                    }

                }.bind(this))
                .catch(function (error) {
                    currentObj.errormsg = error.response.data.errors;
                    this.$bvToast.toast(error.response.data.errors, {
                        title: 'Error',
                        variant: 'danger',
                        solid: true
                    });
                });

        },



        onSubmit: function (e) {

            this.$validator.validateAll().then(result => {
                if (!result) {
                    return;
                }

                e.preventDefault();
                let currentObj = this;

                if (this.validateSalaryFields()) {
                    let data_val = null;
                    let pb_optimization = false;
                    const config = {
                        headers: { 'content-type': 'multipart/form-data' }
                    }
                    let formData = new FormData();

                    for (let item in e.target) {
                        if (e.target.hasOwnProperty(item)) {
                            const record = e.target[item];
                            if (record.name) {
                                if (record.type == 'checkbox')
                                    data_val = record.checked ? 1 : 0;
                                else if (record.type == 'radio') {
                                    if (record.checked)
                                        data_val = record.value;
                                    else
                                        continue;
                                }
                                else
                                    data_val = record.value;
                                formData.append(record.name, data_val);
                            }
                        }
                    }

                    if (this.salary_settings.contracted_variable_benefits.length > 0 && this.contracted_vbenifit_component == 1) {
                        for (var vb_data in this.salary_settings.contracted_variable_benefits) {
                            for (var vb_child_data in this.salary_settings.contracted_variable_benefits[vb_data].child_components) {
                                console.log(this.salary_settings.contracted_variable_benefits[vb_data].child_components[vb_child_data]);
                                formData.append('contracted_field_' + this.salary_settings.contracted_variable_benefits[vb_data].child_components[vb_child_data].id, this.component_values[this.salary_settings.contracted_variable_benefits[vb_data].child_components[vb_child_data].field_key]);
                            }
                        }
                    }

                    formData.append('employee_id', this.contract.employee_id);
                    formData.append('contract_id', this.contract.id);
                    formData.append('contract_status', this.contract_action);
                    formData.append('contract_field_' + this.salary_settings.reserved_data.gross_salary.id, this.fdata.gross);
                    if (this.fdata.has_probation)
                        formData.append('contract_field_' + this.salary_settings.reserved_data.probation_gross_salary.id, this.probation_salary['probation_gross_salary']);

                    if (this.component_values['rent_free_accommodation'] == 1) {
                        if (this.fdata.rental_amount) {
                            formData.append('contract_field_' + this.salary_settings.reserved_data.rental_amount.id, this.fdata.rental_amount);
                            formData.append('rental_amount' + this.salary_settings.reserved_data.rental_amount.id, this.fdata.rental_amount);
                            formData.append('contract_field_' + this.salary_settings.reserved_data.rent_paid_by_employee.id, this.fdata.rent_paid_by_employee); //non-cash update
                        }
                    }

                    if (this.component_values['conveyance_personal_private'] == 1) {

                        //  if(this.fdata.conveyance_personal_private_cars_upto_2500_cc)
                        //  formData.append('contract_field_'+this.salary_settings.reserved_data.conveyance_personal_private_cars_upto_2500_cc.id, this.fdata.conveyance_personal_private_cars_upto_2500_cc);

                        //  New slabs for conveyance personal/private related updates: Sohel

                        if (this.fdata.conveyance_personal_private_cars_upto_1500_cc)
                            formData.append('contract_field_' + this.salary_settings.reserved_data.conveyance_personal_private_cars_upto_1500_cc.id, this.fdata.conveyance_personal_private_cars_upto_1500_cc);

                        if (this.fdata.conveyance_personal_private_cars_1501_to_2000_cc)
                            formData.append('contract_field_' + this.salary_settings.reserved_data.conveyance_personal_private_cars_1501_to_2000_cc.id, this.fdata.conveyance_personal_private_cars_1501_to_2000_cc);

                        if (this.fdata.conveyance_personal_private_cars_2001_to_2500_cc)
                            formData.append('contract_field_' + this.salary_settings.reserved_data.conveyance_personal_private_cars_2001_to_2500_cc.id, this.fdata.conveyance_personal_private_cars_2001_to_2500_cc);

                        //  New slabs for conveyance personal/private related updates: Sohel

                        if (this.fdata.conveyance_personal_private_cars_above_2500_cc)
                            formData.append('contract_field_' + this.salary_settings.reserved_data.conveyance_personal_private_cars_above_2500_cc.id, this.fdata.conveyance_personal_private_cars_above_2500_cc);

                    }


                    if (this.fdata.tax_policy)
                        formData.append('contract_field_' + this.salary_settings.reserved_data.tax_policy.id, this.fdata.tax_policy);

                    formData.append('department_id', this.fdata.department_id);
                    formData.append('employee_type_id', this.fdata.employee_type_id);
                    formData.append('jobposition_id', this.fdata.jobposition_id);
                    formData.append('branch_id', this.fdata.branch_id);

                    //Sohel: New mappings update
                    if (this.cost_center && this.cost_center.length > 0) {
                        formData.append('cost_center', JSON.stringify(this.cost_center));
                    }
                    //Sohel: New mappings update

                    let aj_skip = this.form_ajax_validated ? true : false;

                    /* start custom field changes*/
                    for (let [key, value] of Object.entries(this.ccdata)) {
                        var nm = 'cc_field_' + `${key}`;
                        var fval = `${value}`;
                        formData.append(nm, fval);
                        //console.log(nm +':'+ fval);
                    }
                    //return 1;
                    /* end custom field changes*/

                    if (this.validateFormOverview(aj_skip, true)) {
                        if (!this.validateSalaryFields()) {
                            this.$refs.wizard.changeTab(0, 1);
                            return false;
                        }

                    } else {
                        this.$refs.wizard.changeTab(0, 0);
                        return false;
                    }

                    if (this.contract_action == 'activate') {
                        if (!this.form_ajax_validating) {
                            var confirm_message = (this.$acl['contract/add'] > 2) ? 'Saving this contract will be submitted for approval. After successful approval this contract will be activated and the last active contract will be ended irrespective of whether end date is provided or not. Do you want to continue?' : 'Saving this contract will create a new active contract and will end the last active contract irrespective of whether end date is provided or not. Do you want to continue?';

                            this.$bvModal.msgBoxConfirm(confirm_message, { title: 'Confirm contract saving', size: 'sm', buttonSize: 'sm', okVariant: 'primary', okTitle: 'YES', cancelTitle: 'NO', footerClass: 'p-2', hideHeaderClose: false, centered: true })
                                .then(value => {
                                    if (value) {
                                        this.saveContractData(formData, config);
                                        //this.$refs.wizard.changeTab(0,0);
                                    }
                                })
                                .catch(err => {
                                    // An error occurred
                                });
                        }
                    } else {
                        this.saveContractData(formData, config);
                        //this.$refs.wizard.changeTab(0,0);
                    }
                }
            });
        },

        createMask: function (string) {
            string = this.moneyFormat(string);
            return string;
        },

        destroyMask: function (string) {
            return string.replace(/\,/g, '');
        },

        changeMoneyFormate: function (value) {
            this.fdata.gross_display = this.moneyFormat(value);
            this.fdata.gross = value.replace(/\,/g, '');
        },
        getDepartments: function () {
            axios.get(this.$api_url + '/department/list')
                .then(function (response) {

                    this.department = [{ value: null, text: "Select..." }].concat(response.data);

                    //this.fdata.department_id = null;
                    //alert(this.department[this.fdata.department_id]['text']);

                }.bind(this));

        },
        getEmployeeTypes: function(){
             axios.get(this.$api_url+'/employeetype/list')
             .then(function (response) {
                   this.employee_type = [{ value: null, text: "Select..." } ] . concat(response.data);
             }.bind(this));
        },
        getJobPosition: function () {

            axios.get(this.$api_url + '/jobposition/options', {
                params: {

                }
            }).then(function (response) {

                //this.jobposition = [{ value: null, text: "Select..." } ] . concat(response.data);
                ///this.fdata.jobposition_id = null;
                this.jobposition = [{ value: null, text: "Select..." }].concat(response.data);
            }.bind(this));
        },

        getBranches: function () {
            axios.get(this.$api_url + '/branch/list')
                .then(function (response) {
                    this.branch = [{ value: null, text: "Select..." }].concat(response.data);
                }.bind(this));

        },

        getLeavePolicies: function () {

            //alert(JSON.stringify(this.addons));

            if (!this.addons.includes('Roster')) {
                axios.get(this.$api_url + '/leave/policy/list')
                    .then(function (response) {
                        this.leavePolicies = [{ value: 0, text: "Select..." }].concat(response.data);
                    }.bind(this));
            }
        },
        getRosterLeavePolicies: function () {
            if (this.addons.includes('Roster')) {
                axios.get(this.$api_url + '/leave-attendance/leave/policy/list')
                    .then(function (response) {
                        this.rosterLeavePolicies = [{ value: 0, text: "Select..." }].concat(response.data);
                    }.bind(this));
            }
        },

        getCurrFiscalYear: function () {
            axios.get(this.$api_url + '/getcurrentfiscalyear')
                .then(function (response) {
                    this.curr_fiscal_year = response.data;
                }.bind(this));
        },




        getCompanyData: function () {
            if (!this.checkNet()) return false;
            axios.get(this.$api_url + '/company/details', {
                params: {
                    //id: x
                }
            }).then(function (response) {

                if (response.data.length != 0) {
                    this.addons = response.data.module_disabled;
                    this.getLeavePolicies(); //Roster Leave Policy Update CST v2
                    this.getRosterLeavePolicies();  //Roster Leave Policy Update CST v2
                }
            }.bind(this));
        },

        getCostCenters: function () {
            let currentObj = this;
            axios.get(this.$api_url + '/get-all-cost-center', {
                params: {
                    status: 1
                }
            }).then(function (response) {
                this.cost_centers = response.data;
                //console.log(this.cost_centers);

            }.bind(this)).catch(function (error) {
                currentObj.serverError(error);
            });
        },
        /*start custom field changes*/
        loadCustomFileds() {
            axios.get(this.$api_url + '/custom/attributes/linked/contract', {
                params: {
                }
            }).then(function (response) {
                this.customfieldsdata = response.data;
            }.bind(this));
        },
        getContractCustomData: function () {
            axios.get(this.$api_url + '/contractcustomfields/' + this.contract.id, {
                params: {
                }
            }).then(function (response) {
                this.ccdata = response.data;
            }.bind(this));
        },
        /*end custom field changes*/

        /*Contract effective date Start*/
        syncEffectiveDate() {
            if (this.sameAsStartDate) {
                this.fdata.effective_date = this.fdata.contract_start;
            }
        },
        /*Contract effective date End*/

        //Sohel: New mappings update
        addCostCenterItem() {
            this.$validator.validateAll().then(result => {
                if (!result) {
                    return;
                }
                //Check selection
                if (!this.selectedCostCenter) {
                    console.warn('Stopped: No cost center selected');
                    return;
                }

                //Duplicate check
                const isDuplicate = this.cost_center.some(
                    c => c.cost_center_id === this.selectedCostCenter
                );

                if (isDuplicate) {
                    // alert("This cost center is already added.");
                    this.$bvToast.toast("This cost center is already added.", {
                        title: 'Error',
                        variant: 'danger',
                        solid: true
                    });
                    return;
                }

                //Total percentage calculation
                const totalPercentage = this.cost_center.reduce(
                    (sum, c) => sum + Number(c.component_percentage),
                    0
                );

                if (totalPercentage + Number(this.componentPercentage) > 100) {
                    // alert('Cannot add this cost center. Total percentage cannot exceed 100%.');
                    this.$bvToast.toast("Cannot add this cost center. Total percentage cannot exceed 100%.", {
                        title: 'Error',
                        variant: 'danger',
                        solid: true
                    });
                    return;
                }

                //Add item
                const newItem = {
                    cost_center_id: this.selectedCostCenter,
                    component_percentage: Number(this.componentPercentage)
                };

                console.log('Adding item:', newItem);

                this.cost_center.push(newItem);

                this.$root.$emit('bv::hide::modal', 'bv-modal-select-cost-center');

                //Reset inputs
                this.selectedCostCenter = null;
                this.componentPercentage = 100;

                // Remaining percentage
                const remainingPercentage = 100 - this.cost_center.reduce(
                    (sum, c) => sum + Number(c.component_percentage),
                    0
                );

                this.remainingPercentage = remainingPercentage;
            });

        },
        removeCostCenter(index) {
            this.cost_center.splice(index, 1);
            // Remaining percentage
            const remainingPercentage = 100 - this.cost_center.reduce(
                (sum, c) => sum + Number(c.component_percentage),
                0
            );

            this.remainingPercentage = remainingPercentage;
        },
        getCostCenterName(id) {
            const cc = this.cost_centers.find(c => c.id === id);
            return cc ? cc.name : "";
        },
        selectCostCenter() {
            this.$root.$emit('bv::show::modal', 'bv-modal-select-cost-center');
        },
        //Sohel: New mappings update

    },
    created: function () {
        this.loadGeneralSettings();
        this.loadContractInfo();
        this.getCompanyData();
        this.getDepartments();
        this.getEmployeeTypes();
        this.getJobPosition();
        this.getCostCenters();
        this.getBranches();
        //this.getLeavePolicies(); //Roster Leave Policy Update CST v2
        //this.getRosterLeavePolicies();  //Roster Leave Policy Update CST v2
        this.getCurrFiscalYear();
        this.loadCustomFileds(); /*custom field changes*/


        //this.getContractLists();
    }
}
</script>
